import { ElementRef, ViewChild, ViewChildren, ChangeDetectorRef, Component, OnInit, OnDestroy, HostListener, QueryList } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
// MatSnackBar removed; using ToastrService
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { global } from '../../global';
import { catchError, concatMap, map } from 'rxjs/operators';
import { concat, EMPTY, Observable, of, Subscription, from, timer, forkJoin } from 'rxjs';
import { MetaApiService, MetaApiDownloadFase } from 'src/app/services/meta-api.service';
import { FmpIntradiaService } from 'src/app/services/fmp-intradia.service';
import { ApiService } from 'src/app/api.service';
import { MercadosInterface, SelectModel, SelectModelFrec } from '../models/models.component';
import { DialogNameComponent } from '../dialog-name/dialog-name.component';
import { DialogCondicionComponent } from '../condiciones/dialog-condicion/dialog-condicion.component';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { SseService } from 'src/app/services/SseService';
import { ToastrService } from 'ngx-toastr';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { id } from '@swimlane/ngx-datatable';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { Condicion, IndicatorResponse, MenuItem, MenuService } from '../../services/menu.service';  // Add this import
import { SelectionModel } from '@angular/cdk/collections';
import { TemaService } from 'src/app/services/tema.services';
import { CustomizerSettingsService } from '../customizer-settings/customizer-settings.service';
import { DialogConfirmacionComponent } from '../dialog-confirmacion/dialog-confirmacion.component';
import { PlanificadorService } from '../models/control.service';
import { EditarParametrosCondicionComponent } from './editar-parametros-condicion/editar-parametros-condicion.component';
import { param } from 'jquery';
import { HelpDialogComponent, HelpDialogData } from '../common/help-dialog/help-dialog.component';
import { StrategyFactoryResultsTableComponent } from './results-table/results-table.component';
import { N } from '@angular/cdk/keycodes';
import { ActivatedRoute } from '@angular/router';
import { ChatIaDialogComponent, ContextoAsistenteUI, DireccionUI } from '../chat-ia-dialog/chat-ia-dialog.component';
import { LoginDialogComponent } from '../broker/login-dialog/login-dialog.component';
import { DialogGuardarComponent } from '../dialog-guardar/dialog-guardar.component';
import { MAX_NOMBRE_CARTERA, nombreCarteraConSufijo } from '../../utils/nombre-cartera.util';

interface Condition {
  label: string;
  action: string;
  type: string;
  id: number;
  idsList: number[];
}

interface Beneficio {
  intervalosOperativa: number;
  beneficioNeto: number;
  beneficioNetoPor: number;
  acumuladoAnualPor: number;
  tasaAnualCompuestaPor: number;
  numeroOperaciones: number;
}

interface Riesgos {
  retrocesoMaximoPor: number;
  retrocesoMaximo: number;
  retrocesoMaximoDiarioPor: number;
  volatilidadIntervalo: number;
  volatilidadAnual: number;
  intervalosSinMaximos: number;
  ratioBeneficioRiesgo: number;
}

interface Metrics {
  beneficio: Beneficio;
  riesgos: Riesgos;
  idModelo: number;
  valorriesgo: number;

}

@Component({
  selector: 'app-strategy-factory',
  templateUrl: './strategy-factory.component.html',
  styleUrls: ['./strategy-factory.component.scss']
})
export class StrategyFactoryComponent implements OnInit {
  @ViewChild('ctxMenu') private ctxMenuRef?: ElementRef<HTMLElement>;
  @ViewChild('ctxMenu2') private ctxMenu2Ref?: ElementRef<HTMLElement>;
  @ViewChild('tablaModelosSeleccionados') tablaModelosSeleccionados?: any;
  @ViewChild('condicionesViewport') condicionesViewport?: CdkVirtualScrollViewport;
  @ViewChildren(StrategyFactoryResultsTableComponent) private resultTables?: QueryList<StrategyFactoryResultsTableComponent>;
  public stopLoss: boolean = true;
  public stopLossDinamico: boolean = true;
  public condicionaguardar: string = '';
  public habilitarRangoRetroceso: boolean = true;
  public mayorRetrocesoFinal: number | null = null;
  public pasoRetroceso: number | null = 10;
  public proFit: boolean = false;
  public proFitValue: number | null = 10;
  public habilitarRangoStopLoss: boolean = true;
  public stopLossValueFinal: number | null = 20;
  public pasoStopLossValue: number | null = 1;
  public diasSalida: boolean = false;
  public diasSalidaValue: number | null = 0;
  public salidaFinDiaActivo: boolean = false;
  loading = false;
  loadingIndicadoresCondiciones = false;
  loadingOptimizacion = false;
  loadingOptimizacion2 = false;
  loadingOptimizacion3 = false;
  loadingOptimizacionFinal = false;

  fracciones: boolean = false;
  error: string | null = null;
  menuData: MenuItem[] = [];
  condicionesSeleccionadas: number[] = [];
  indicadoresSeleccionados: number[] = [];
  token: string = '';
  public selectedTab: number = 0;
  // Índice de la subtaba dentro de la pestaña "Mejoras"
  public selectedMejorasSubtab: number = 0;
  tiposRiesgo = ['LIMITADO', 'FIJO'];
  selectedTipoRiesgo = 'LIMITADO';
  tipoCuenta: string = 'MARGEN';
  margenRequeridoPor: number | null = 30;
  controlMarginCall: number | null = 75;
  riesgoMaximo: number | null = 50;
  // Properties for table data
  selectedType: 'TECNICOS' | 'RATIOS' | 'LISTAS' | 'PATRONES' = 'TECNICOS';
  selectedCondicion: Condicion;
  displayedColumns: string[] = ['index', 'label', 'acciones'];
  displayedColumnsindi: string[] = ['index', 'label', 'action'];
  indicadoresDataSourceTecnicos = new CdkTableVirtualScrollDataSource<Condition>([]);
  indicadoresDataSourceRatios = new CdkTableVirtualScrollDataSource<Condition>([]);
  indicadoresDataSourceListas = new CdkTableVirtualScrollDataSource<Condition>([]);
  indicadoresDataSourcePatrones = new CdkTableVirtualScrollDataSource<Condition>([]);
  condicionesDataSource = new CdkTableVirtualScrollDataSource<Condition>([]);
  allIndicadoresTecnicos: Condition[] = [];
  allIndicadoresRatios: Condition[] = [];
  allIndicadoresListas: Condition[] = [];
  allIndicadoresPatrones: Condition[] = [];
  allCondiciones: Condition[] = [];
  sortColumnTecnicos: 'label' | 'action' | null = null;
  sortDirectionTecnicos: 'asc' | 'desc' = 'asc';
  sortColumnRatios: 'label' | 'action' | null = null;
  sortDirectionRatios: 'asc' | 'desc' = 'asc';
  sortColumnListas: 'label' | 'action' | null = null;
  sortDirectionListas: 'asc' | 'desc' = 'asc';
  sortColumnPatrones: 'label' | 'action' | null = null;
  sortDirectionPatrones: 'asc' | 'desc' = 'asc';
  sortColumnCondiciones: 'label' | 'action' | null = null;
  sortDirectionCondiciones: 'asc' | 'desc' = 'asc';
  private chatIaDialogRef: any = null;
  private chatIaOnSave: ((condiciones: string[], direcciones: DireccionUI[]) => void) | null = null;
  selectedRowTecnico: Condition | null = null;
  actualcondicion: string = '';
  selectedRowRatio: Condition | null = null;
  selectedRowLista: Condition | null = null;
  selectedRowPatron: Condition | null = null;
  private explicitlyDeselectedRows = new Set<any>();
  // Properties for filters
  indicadoresFilterValue: string = '';
  condicionesFilterValue: string = '';
  indicadoresSearchOpen: boolean = false;
  @ViewChild('indicadoresSearchInput') indicadoresSearchInputRef?: ElementRef<HTMLInputElement>;
  condicionesSearchOpen: boolean = false;
  @ViewChild('condicionesSearchInput') condicionesSearchInputRef?: ElementRef<HTMLInputElement>;
  condicionCopiada: any = null;
  tabTitles = {
    0: 'Modelos IA',
    1: 'Mejora 1',
    2: 'Optimizar Modelo',
    3: 'Reevaluación',
    4: 'Condiciones'
  };
  results: AlgorithmResults = {
    topResults: [],
    seleccionado: [],
    seleccionado2: [],
    seleccionado3: [],
    seleccionado4: [],
    seleccionadoReevaluacion: [],
    topResultsOptimizado: [],
    topResultsOptimizado2: [],
    topResultsOptimizado3: [],
    topResultsOptimizado4: [],
    topResultsReevaluacion: [],
    reevaluados: []
  };

  indicatorTypes: SelectModel[] = [];
  allIndicatorTypes: any;

  public indicatorsNew: string[] = [];
  public indicatorsFundamentales: string[] = [];
  public indicatorsIa: string[] = [];
  public condicionesIa: string[] = [];
  public urlbackend: String = global.url;
  // Parámetros opcionales para la búsqueda
  tasaCompuestaObjetivo: number | null = 10;
  mayorRetrocesoObjetivo: number | null = 40;
  // Nº mínimo de operaciones para dar una estrategia por válida (0 = sin filtro)
  minimoOperaciones: number | null = 100;
  stopLossValue: number | null = 20;
  capitalInicial: number | null = 100000;
  maxcombinaciones: number | null = 5;
  public combinaciones: boolean = false;
  readonly today: string = new Date().toISOString().split('T')[0];
  fechaInicial: string = '2023-01-01';
  private readonly fechaInicialDefault: string = '2023-01-01';
  fechaMinimaDisponible: string = '2023-01-01';
  fechaFinal: string = new Date().toISOString().split('T')[0];
  public selectedIdMercado: any = 8;
  frecuencySelect: SelectModelFrec[] = [];
  selectedFrecuency: number = 6;
  public idModelo: number | null = 0;
  public sectype: string = 'STK';
  public metaapiAccountId: string = '';
  public isLoadingMetaapi: boolean = false;
  public candlesDownloadBatch: number = 0;
  public candlesDownloadTotal: number = 0;
  public candlesDownloadExpected: number = 0;
  public candlesDownloadSymbol: string = '';
  public candlesDownloadFase: MetaApiDownloadFase | '' = '';
  /** Que proveedor esta descargando: cambia las etiquetas y la unidad del progreso. */
  public descargaFuente: 'metaapi' | 'fmp' | '' = '';
  public metaapiConnected: boolean = false;
  public isDark: boolean = false;
  public tipoCompras: string = 'LIMITADO';
  public valorRiesgo: number | null = 1000;
  public habilitarRangoRiesgo: boolean = true;
  public valorRiesgoFinal: number | null = 1000;
  public pasoRiesgo: number | null = 10;
  public notificacion: string = '';
  public omitidas: number = 0;
  public validas: number = 0;
  public resultadosTemporal: Metrics[] = [];
  // Descartadas por no llegar a "Mín. Operaciones": no entran en topResults.
  public descartadasPorOperaciones: number = 0;
  // Índice idModelo+valorriesgo -> métricas, para consultar el nº de operaciones en O(1)
  // en cuanto llega el evento 'result'/'omitido' (el evento 'resultados' del modelo llega antes).
  private metricsPorClave = new Map<number, Metrics>();
  public omitidasOptimizadas: number = 0;
  public texto: string = ">>"
  public mouseSobreDiv: boolean = false;
  private _panelCloseTimer: any = null;
  public modeloDiv: boolean = localStorage.getItem('strategyfactory_panel_modeloDiv') !== 'false';
  public cartera: boolean = localStorage.getItem('strategyfactory_panel_cartera') !== 'false';
  public showParametrosSeleccionados: boolean = true;
  public isPlanificador: boolean = false;
  public activatedModelo: boolean = false;
  public subtema: Subscription;
  public fechaInicialReevaluar: string = '2023-01-01';
  public fechaFinalReevaluar: string = new Date().toISOString().split('T')[0];

  public pendientes: number = 0;
  public total: number = 0;
  public completados: number = 0;

  public pendientesOptimizacion: number = 0;
  public totalOptimizacion: number = 0;
  public completadosOptimizacion: number = 0;

  public pendientesCombinacion: number = 0;
  public totalCombinacion: number = 0;
  public completadosCombinacion: number = 0;
  public totalgeneral: number = 0;
  public pendientesgeneral: number = 0;
  public completadosgeneral: number = 0;
  public validasOptimizadas: number = 0;
  public showContextMenu = false;
  showContextMenu2: boolean = false;
  public contextMenuX = 0;
  public contextMenuY = 0;
  public contextMenuX2 = 0;
  public contextMenuY2 = 0;
  public selectedResult: any = null;
  public optimalWallet: OptimalWallet = {
    apalancamiento: 1,
    bajista: false,
    capitalinicial: 100000.0,
    idcartera: 0,
    nombre: '',
    valorLiquidativo: 100000,
    valorliquidativoTemp: 0.0,
    riesgomaximo: 50.0,
    tipocuenta: 'MARGEN',
    tiporiesgo: 'LIMITADO',
    riesgo: 1000.0,
    comisionbroker: 10.0,
    idmercado: 0,
    intervalotiempo: 2,
    prima: false,
    participacion: false,
    simulado: true,
    poderCompra: 200000,
    numeroReconfiguracion: 0,
    stopLoss: 20,
    profit: 10,
    capitales: [1000.0, 1000.0],
    fondosDisponibles: 100000,
    margen: 0,
    margenRequeridoPor: 30,
    controlMarginCall: 75.0,
    lista: 0,
    nOperaciones: 0,
    maxDiferenciaCierres: 0.0,
    rendimientoNeto: 0.0,
    rendimientomedioanual: 0.0,
    rendimientoacumuladoanual: 0.0,
    tasacrecimientoanualcompuesto: 0.0,
    periodosoperativa: 0,
    beneficioneto: 0.0,
    beneficionetoporcentual: 0.0,
    mayorretrocesodesdemaximo: 0.0,
    mayorretrocesodesdemaximoporcentual: 0.0,
    mediabeneficioperdidaporcentual: 0.0,
    sumaresiduosbeneficioperdidaporcentual: 0.0,
    volatilidadperiodo: 0.0,
    volatilidadanual: 0.0,
    mesesdd: 0,
    maximoretrocesoperiodo: 0.0,
    sumarrendimientosanuales: 0.0,
    prombeneficiointervalo: 0.0,
    prombeneficionintervaloporcentual: 0.0,
    sumatorio: false,
    coeficientevolatilidadanual: 1.0,
    ratiobeneficioriesgo: 0.0,
    modelodesde: '',
    efectivo: 100000.0,
    gastosGestionPor: 1.0,
    gastosPrestamoPor: 8.0,
    nRecalcular: 0,
    idModelo: 0,
    liquidativos: null,
    sincro: true, auto: false,
    idCarteras: [0, 0, 0, 0, 0],
    subCarteras: '',
    chkgastogest: true,
    chkgastoprest: true,
    chkcomisionbroker: true
  };

  mercados: MercadosInterface[] = [
    {
      idmercado: 0,
      iso: "",
      nombre: "Cargando mercados...",
      tipo: 0, sectype: 'STK', metaapi: false
    }
  ];
  // Datos de ejemplo para usar como respaldo si la API no está disponible
  private mockData: AlgoritmoResult = {
    "executionTime": "102137 ms",
    "useDemoData": true,
    "totalOperations": 516,
    "totalResults": 14,
    "maxCombinaciones": 5,
    "conditionsEvaluated": 14,
    "tasaCompuestaObjetivo": 400,
    "totalConditions": 20,
    "mayorRetrocesoObjetivo": 20,
    "topResults": [],
    "topResultsOptimizado": [],
    "topResultsOptimizado2": [],
    "topResultsOptimizado3": [],
    "topResultsOptimizado4": [],
    "topResultsReevaluacion": [],
    "seleccionado": [],
    "seleccionado2": [],
    "seleccionado3": [],
    "seleccionado4": [],
    "seleccionadoReevaluacion": [],
    "reevaluados": [],
    "bestGroup": {
      "compoundRate": 441.7472655607338,
      "score": -33.560922579224794, "modelMeetsCriteria": "",
      "otherResults": [
      ],
      "maxDrawdown": 17.09757414199085,
      "maxDrawdownObjetivo": 20,
      "beneficio": 441747.2655607338,
      "maxDrawdownValor": 17097.57414199085,
      "fracciones": false,
      "tiporiesgo": "LIMITADO",
      "id": 1015,
      "conditions": [
      ],
      "type": "Condition",
      "message": "Se ha seleccionado la mejor condición según los criterios de optimización"
    }
  };

  // Example object typed with the new Metrics interface
  public metricsExample: Metrics = {
    beneficio: {
      intervalosOperativa: 752,
      beneficioNeto: 0.0,
      beneficioNetoPor: 0.0,
      acumuladoAnualPor: 0.0,
      tasaAnualCompuestaPor: 0.0,
      numeroOperaciones: 0
    },
    riesgos: {
      retrocesoMaximoPor: 0.0,
      retrocesoMaximo: 0.0,
      retrocesoMaximoDiarioPor: 0.0,
      volatilidadIntervalo: 0.0,
      volatilidadAnual: 0.0,
      intervalosSinMaximos: 752,
      ratioBeneficioRiesgo: 0.0,
    },
    idModelo: 0,
    valorriesgo: 0.0
  };

  // Add subscription property
  private algorithmSubscription: Subscription | null = null;
  private algorithmSubscription2: Subscription | null = null;
  private algorithmSubscription3: Subscription | null = null;
  private algorithmSubscriptionFinal: Subscription | null = null;
  private currentJobId: string | null = null;       // búsqueda principal (slot 0/1)
  private currentJobIdOpt: string | null = null;    // optimización (slot 2, idpaso==2)
  private currentJobIdFinal: string | null = null;  // optimización final / reevaluación (slot 3, idpaso==3/5)

  // Agregar esta propiedad a la clase
  selectedTableSource: 'main' | 'optimized' | 'optimized2' | 'optimized3' | 'reevaluacion' = 'main';

  // Add these properties
  selectionTecnicos = new SelectionModel<any>(true, []);
  selectionRatios = new SelectionModel<any>(true, []);
  selectionListas = new SelectionModel<any>(true, []);
  selectionPatrones = new SelectionModel<any>(true, []);
  // Add new selection model for condiciones
  selectionCondiciones = new SelectionModel<any>(true, []);
  // Add new selection model for reevaluar
  selectionReevaluar = new SelectionModel<ResultItem>(true, []);
  modelosSeleccionadosReevaluarCache: ResultItem[] = []; // Cache estable para el template
  loadingReevaluar = false;
  // true solo si llegó el evento 'done' del backend; distingue fin real de corte de conexión
  reevaluacionCompletada = false;
  displayedColumnsCondiciones: string[] = ['select', 'index', 'label'];
  optimizarCondicionData: any;

  private getResultTableByTabId(tabId: number): StrategyFactoryResultsTableComponent | undefined {
    return this.resultTables?.find(table => table.tabId === tabId);
  }

  private detenerProcesoPrincipal(): void {
    if (this.algorithmSubscription) {
      this.algorithmSubscription.unsubscribe();
      this.algorithmSubscription = null;
    }
    if (this.algorithmSubscription2) {
      this.algorithmSubscription2.unsubscribe();
      this.algorithmSubscription2 = null;
    }
    if (this.currentJobId) {
      this.apisseservice.apiPostNew(`ia/cancelarStrategyFactoryBatch?jobId=${this.currentJobId}`, {}, this.token).subscribe();
      this.currentJobId = null;
    }
    this.loading = false;
  }

  private ejecutarConGuardaProcesoPrincipal(accion: () => void): void {
    if (!this.loading) {
      accion();
      return;
    }
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    this.dialog.open(DialogConfirmacionComponent, {
      width: '380px',
      panelClass: dialogClass,
      data: {
        titulo: 'Proceso principal en ejecución',
        mensaje: 'Hay una búsqueda principal en curso. Para continuar hay que cancelarla. ¿Desea cancelarla?',
        botonConfirmar: 'Cancelar y continuar',
        botonCancelar: 'Volver'
      }
    }).afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.detenerProcesoPrincipal();
        accion();
      }
    });
  }

  onContextMenuGuardar(): void {
    this.ejecutarConGuardaProcesoPrincipal(() => this.guardarPonderador(false, this.selectedResult, this.selectedResult.group));
  }

  // Texto de la condición de una fila de resultado, igual que la rama usada en guardarPonderador (L2618).
  private textoCondicionDeResultado(modelo: ResultItem): string {
    return modelo.type === 'Condition' ? modelo.condition! : (modelo.conditions ?? []).join(' AND ');
  }

  onContextMenuGuardarEnIdeas(): void {
    this.showContextMenu = false;
    if (!this.selectedResult) return;

    // Si la fila sobre la que se hizo click está entre las marcadas, se guardan todas las marcadas;
    // si no, solo esa fila.
    const seleccionMarcada = this.selectionReevaluar.selected;
    const modelos = seleccionMarcada.includes(this.selectedResult) && seleccionMarcada.length > 0
      ? seleccionMarcada
      : [this.selectedResult];

    const condiciones = Array.from(new Set(
      modelos.map(m => this.textoCondicionDeResultado(m)).filter(c => !!c)
    ));
    if (condiciones.length === 0) {
      this.toastr.error('No se pudo determinar la condición a guardar');
      return;
    }

    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    // Flotante y minimizable; otra petición de guardado sustituye a la ventana abierta
    const dialogRef = this.abrirVentanaFlotante<DialogGuardarComponent>('guardar', DialogGuardarComponent, {
      width: '450px',
      panelClass: dialogClass,
      data: {
        condiciones,
        indicatorsIaSinEspacios: this.planificadorsv.indicatorsIaSinEspacios
      }
    }, true);
    if (!dialogRef) return;

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.destinos && result.destinos.length > 0) {
        // Si ya estaba todo guardado, el diálogo ya ha avisado
        if (!result.todoYaEstaba) this.toastr.success('Condición guardada en Ideas correctamente');
        this.recargarIdeas();
      }
    });
  }

  // Recarga la pestaña IDEAS (listaindicadoresporusuario) sin recargar la página.
  private recargarIdeas(): void {
    this.apisseservice.apiPostNew('listaindicadoresporusuario', {}, this.token).subscribe({
      next: (indicators: IndicatorResponse[]) => {
        const conditions: Condition[] = indicators.map(item => ({
          label: item.indicador,
          action: item.contador.toString(),
          type: this.selectedType,
          id: item.id,
          idsList: item.idsList
        }));

        this.allIndicadoresListas = conditions;
        this.indicadoresDataSourceListas.data = this.filterAndSortIndicadores(conditions, this.indicadoresFilterValue, this.sortColumnListas, this.sortDirectionListas);
        this.loadingIndicadoresCondiciones = false;
      },
      error: (error: Error) => {
        console.error('Error loading user indicators:', error);
        this.error = 'Error cargando los indicadores del usuario';
        this.loadingIndicadoresCondiciones = false;
      }
    });
  }

  onContextMenuMejoraFuerzaBruta(): void {
    this.ejecutarConGuardaProcesoPrincipal(() => this.optimizarCondicion(this.selectedResult, 1, false));
  }

  onContextMenuMejoraGenetica(): void {
    this.ejecutarConGuardaProcesoPrincipal(() => this.optimizarCondicion(this.selectedResult, 0, false));
  }

  onContextMenuOptimizarModelo(): void {
    this.ejecutarConGuardaProcesoPrincipal(() => this.mostrareditordeparametros(this.selectedResult));
  }

  // Throttling maps to avoid updating tables too often when many events arrive
  private tableUpdateTimers: Map<number, any> = new Map();
  private tableLastUpdate: Map<number, number> = new Map();
  private tableUpdateIntervalMs: number = 1000; // 1 second

  private updateTableDataSourceForTab(tabId: number | null): void {
    if (tabId == null) {
      return;
    }
    const id = tabId as number;
    const table = this.getResultTableByTabId(id);
    if (!table) return;

    const now = Date.now();
    const last = this.tableLastUpdate.get(id) ?? 0;
    const elapsed = now - last;

    // If enough time has passed, update immediately
    if (elapsed >= this.tableUpdateIntervalMs) {
      try {
        table.updateDataSource();
      } catch (e) { /* ignore errors from update */ }
      this.tableLastUpdate.set(id, Date.now());

      // clear any scheduled timer
      const existing = this.tableUpdateTimers.get(id);
      if (existing) {
        clearTimeout(existing);
        this.tableUpdateTimers.delete(id);
      }
      return;
    }

    // Otherwise schedule a single update at the next available time
    if (!this.tableUpdateTimers.get(id)) {
      const remaining = this.tableUpdateIntervalMs - elapsed;
      const timer = setTimeout(() => {
        try { table.updateDataSource(); } catch (e) { /* ignore */ }
        this.tableLastUpdate.set(id, Date.now());
        this.tableUpdateTimers.delete(id);
      }, remaining);
      this.tableUpdateTimers.set(id, timer);
    }
  }

  private refreshTableViewportForTab(tabId: number): void {
    const table = this.getResultTableByTabId(tabId);
    if (!table) {
      return;
    }
    setTimeout(() => {
      table.refreshViewport();
    }, 100);
  }

  private getTabIndexForOptimizedSource(source: string): number | null {
    // Return stable numeric tab IDs that are independent of mat-tab positions.
    // These IDs are assigned to each `app-strategy-factory-results-table` via its `tabId` input.
    switch (source) {
      case 'main':
        return 100; // Main top results
      case 'optimized':
        return 200; // First optimization results
      case 'optimized2':
        return 201; // Second optimization results
      case 'optimized3':
        return 202; // Third optimization results
      case 'optimized4':
        return 203; // Fourth optimization results (if present)
      case 'reevaluacion':
        return 300; // Reevaluacion results
      default:
        return null;
    }
  }

  private syncTableForOptimizedSource(source: string): void {
    const tabIndex = this.getTabIndexForOptimizedSource(source);
    this.updateTableDataSourceForTab(tabIndex);
  }

  /**
   * Actualiza los contadores de progreso cuando se recibe un evento 'batchProgress' desde SSE.
   * Se aceptan diferentes formas de payload y se asignan los campos disponibles sin provocar errores.
   */
  private mostrarProgresoBatch(data: any, _context?: any): void {
    if (!data) {
      return;
    }

    // Manejo del nuevo formato de batchProgress con símbolos/modelos
    if (data.totalSymbols !== undefined || data.processedSymbols !== undefined) {
      // Formato nuevo: {"totalModels":6,"processedSymbols":22,"event":"batchProgress","totalSymbols":96,"percent":22.92}
      if (data.totalSymbols !== undefined) {
        this.total = Number(data.totalSymbols) || 0;
      }
      if (data.processedSymbols !== undefined) {
        this.completados = Number(data.processedSymbols) || 0;
      }
      if (data.totalSymbols !== undefined && data.processedSymbols !== undefined) {
        this.pendientes = (Number(data.totalSymbols) || 0) - (Number(data.processedSymbols) || 0);
      }
      if (data.totalModels !== undefined) {
        this.notificacion = `Procesando ${data.totalModels} modelo(s): ${data.processedSymbols || 0}/${data.totalSymbols || 0} símbolos (${(data.percent || 0).toFixed(2)}%)`;
      }
    } else {
      // Formato antiguo: campos pendientes/total/completados
      if (data.pendientes !== undefined) {
        this.pendientes = Number(data.pendientes) || 0;
      }
      if (data.total !== undefined) {
        this.total = Number(data.total) || 0;
      }
      if (data.completados !== undefined) {
        this.completados = Number(data.completados) || 0;
      }
    }

    // Asignaciones seguras para combinaciones (si vienen)
    if (data.pendientesCombinacion !== undefined) {
      this.pendientesCombinacion = Number(data.pendientesCombinacion) || 0;
    }
    if (data.totalCombinacion !== undefined) {
      this.totalCombinacion = Number(data.totalCombinacion) || 0;
    }
    if (data.completadosCombinacion !== undefined) {
      this.completadosCombinacion = Number(data.completadosCombinacion) || 0;
    }

    // Asignaciones seguras para optimización (si vienen)
    if (data.pendientesOptimizacion !== undefined) {
      this.pendientesOptimizacion = Number(data.pendientesOptimizacion) || 0;
    }
    if (data.totalOptimizacion !== undefined) {
      this.totalOptimizacion = Number(data.totalOptimizacion) || 0;
    }
    if (data.completadosOptimizacion !== undefined) {
      this.completadosOptimizacion = Number(data.completadosOptimizacion) || 0;
    }

    // Actualizar totales agregados
    this.totalgeneral = (Number(this.total) || 0) + (Number(this.totalCombinacion) || 0);
    this.pendientesgeneral = (Number(this.pendientes) || 0) + (Number(this.pendientesCombinacion) || 0);
    this.completadosgeneral = (Number(this.completados) || 0) + (Number(this.completadosCombinacion) || 0);

    // Mensajes opcionales (solo si no viene el formato de símbolos)
    if (data.totalSymbols === undefined) {
      if (data.mensaje !== undefined) {
        this.notificacion = String(data.mensaje);
      } else if (data.msg !== undefined) {
        this.notificacion = String(data.msg);
      }
    }
  }

  constructor(
    public planificadorsv: PlanificadorService, private toastr: ToastrService,
    private http: HttpClient,
    private apiService: ApiService,
    private menuService: MenuService,  // Add this line
    public dialog: MatDialog,
    private cookieService: CookieService,
    private apisseservice: SseService,
    private temaservicio: TemaService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private metaApiService: MetaApiService,
    private fmpIntradiaService: FmpIntradiaService
  ) { }
  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTab = event.index;
    console.log('Tab changed to index:', event.index);
    
    // Forzar detección de cambios
    this.cdr.detectChanges();
    
    // Refrescar viewport de la tabla de modelos seleccionados cuando se cambia al tab 3 (Reevaluación)
    if (event.index === 3 && this.tablaModelosSeleccionados) {
      setTimeout(() => {
        this.tablaModelosSeleccionados.refreshViewport();
      }, 100);
    }

    // Refrescar viewport de Condiciones cuando se cambia al tab 4: el cdk-virtual-scroll-viewport
    // se crea/oculta con el mat-tab y no recalcula su tamaño solo al volverse visible.
    if (event.index === 4 && this.condicionesViewport) {
      setTimeout(() => {
        this.condicionesViewport?.checkViewportSize();
        this.cdr.detectChanges();
      }, 100);
    }

    // Refrescar viewport de todas las tablas visibles después del cambio de tab
    // (no se llama updateDataSource porque preserveContent=true mantiene el contenido
    // y reconstruir los datos rompería las referencias del SelectionModel)
    setTimeout(() => {
      this.resultTables?.forEach(table => {
        table.refreshViewport();
      });
      this.cdr.detectChanges();
    }, 150);
  }

  onMejorasSubtabChange(event: MatTabChangeEvent): void {
    console.log('Mejoras subtab changed to index:', event.index);
    this.selectedMejorasSubtab = event.index;
    
    // Forzar detección de cambios y refrescar tablas de mejora
    this.cdr.detectChanges();
    
    setTimeout(() => {
      // Refrescar tablas específicas de cada subtab de mejoras
      const tabIds = [200, 201, 202]; // Mejora 1, 2, Final
      const tabId = tabIds[event.index];
      if (tabId) {
        const table = this.resultTables?.find(t => t.tabId === tabId);
        if (table) {
          table.refreshViewport();
        }
      }
      this.cdr.detectChanges();
    }, 150);
  }

  startResizing(event: MouseEvent, column: HTMLElement) {
    if (column && column.tagName === 'DIV') {
      const dataKey = column.getAttribute('data-key') || '';
      const minWidth = 200;
      const maxWidth = Math.floor(window.innerWidth * 0.7);
      const initialX = event.clientX;
      const initialWidth = column.offsetWidth;

      const mouseMoveListener = (mouseEvent: MouseEvent) => {
        let width = initialWidth + (mouseEvent.clientX - initialX);
        if (width < minWidth) width = minWidth;
        if (width > maxWidth) width = maxWidth;
        column.style.width = width + 'px';
      };

      const mouseUpListener = () => {
        document.removeEventListener('mousemove', mouseMoveListener);
        document.removeEventListener('mouseup', mouseUpListener);
        try {
          const w = column.offsetWidth;
          if (dataKey) localStorage.setItem(dataKey, String(w));
        } catch (e) {}
      };

      document.addEventListener('mousemove', mouseMoveListener);
      document.addEventListener('mouseup', mouseUpListener);
    }
  }

  private restoreSavedWidths(): void {
    try {
      const keys = ['strategyfactory_col_cartera_v2', 'strategyfactory_col_modelo'];
      keys.forEach(key => {
        const v = localStorage.getItem(key);
        if (v) {
          const el = document.querySelector(`[data-key="${key}"]`) as HTMLElement;
          if (el) el.style.width = v + 'px';
        }
      });
    } catch (e) {}
  }
  actualizarSlideStoploss(event: any) {
    this.stopLoss = event.checked;
    if (!this.stopLoss) {
      this.stopLossDinamico = false;
      this.habilitarRangoStopLoss = false;
      this.stopLossValueFinal = null;
      this.pasoStopLossValue = null;
    } else if (this.habilitarRangoStopLoss) {
      this.enforcePasoStopLossMin();
    }
  }

  actualizarSlideStoplossDinamico(event: any) {
    this.stopLossDinamico = event.checked;
  }

  actualizarSlideProfit(event: any) {
    this.proFit = event.checked;
  }
  actualizarSlideDiasSalida(event: any) {
    this.diasSalida = event.checked;
  }
  onTipoEstrategiaChange(event: any) {
    this.optimalWallet.bajista = event.value === 'bajista';
  }
  actualizarRangoRiesgo(event: any) {
    this.habilitarRangoRiesgo = event.checked ?? event.target?.checked ?? false;
    if (!this.habilitarRangoRiesgo) {
      this.valorRiesgoFinal = null;
      this.pasoRiesgo = null;
    } else {
      if (this.valorRiesgo !== null) {
        if (this.valorRiesgoFinal === null || this.valorRiesgoFinal < this.valorRiesgo) {
          this.valorRiesgoFinal = this.valorRiesgo;
        }
      }
      this.enforcePasoRiesgoMin();
    }
  }
  onValorRiesgoBlur(): void {
    this.valorRiesgo = this.convertirValorNumerico(this.valorRiesgo);
    if (this.habilitarRangoRiesgo && this.valorRiesgo !== null) {
      if (this.valorRiesgoFinal === null || this.valorRiesgoFinal < this.valorRiesgo) {
        this.valorRiesgoFinal = this.valorRiesgo;
      }
    }
    this.enforcePasoRiesgoMin();
  }

  onValorRiesgoFinalBlur(): void {
    this.valorRiesgoFinal = this.convertirValorNumerico(this.valorRiesgoFinal);
    if (this.habilitarRangoRiesgo && this.valorRiesgo !== null && this.valorRiesgoFinal !== null) {
      if (this.valorRiesgoFinal < this.valorRiesgo) {
        this.valorRiesgoFinal = this.valorRiesgo;
      }
    }
    this.enforcePasoRiesgoMin();
  }

  actualizarRangoStopLoss(event?: any): void {
    const nextState = event?.checked ?? event?.target?.checked ?? event;
    if (nextState !== undefined) {
      this.habilitarRangoStopLoss = !!nextState;
    }

    if (!this.stopLoss) {
      this.habilitarRangoStopLoss = false;
    }

    if (!this.habilitarRangoStopLoss) {
      this.stopLossValueFinal = null;
      this.pasoStopLossValue = null;
      return;
    }

    this.stopLossValue = this.convertirValorNumerico(this.stopLossValue);
    if (this.stopLossValue !== null) {
      if (this.stopLossValueFinal === null || this.stopLossValueFinal < this.stopLossValue) {
        this.stopLossValueFinal = this.stopLossValue;
      }
    }

    this.enforcePasoStopLossMin();
  }

  onStopLossValueBlur(): void {
    this.stopLossValue = this.convertirValorNumerico(this.stopLossValue);
    if (this.habilitarRangoStopLoss && this.stopLossValue !== null) {
      if (this.stopLossValueFinal === null || this.stopLossValueFinal < this.stopLossValue) {
        this.stopLossValueFinal = this.stopLossValue;
      }
    }
    this.enforcePasoStopLossMin();
  }

  onStopLossValueFinalBlur(): void {
    this.stopLossValueFinal = this.convertirValorNumerico(this.stopLossValueFinal);
    if (this.habilitarRangoStopLoss && this.stopLossValue !== null && this.stopLossValueFinal !== null) {
      if (this.stopLossValueFinal < this.stopLossValue) {
        this.stopLossValueFinal = this.stopLossValue;
      }
    }
    this.enforcePasoStopLossMin();
  }

  onPasoStopLossBlur(): void {
    this.pasoStopLossValue = this.convertirValorNumerico(this.pasoStopLossValue);
    this.enforcePasoStopLossMin();
  }

  actualizarRangoRetroceso(event: any): void {
    this.habilitarRangoRetroceso = event.checked ?? event.target?.checked ?? false;
    if (!this.habilitarRangoRetroceso) {
      this.mayorRetrocesoFinal = null;
      this.pasoRetroceso = null;
      return;
    }

    this.mayorRetrocesoObjetivo = this.convertirValorNumerico(this.mayorRetrocesoObjetivo);
    const objetivo = this.mayorRetrocesoObjetivo;
    if (objetivo !== null) {
      if (this.mayorRetrocesoFinal === null || this.mayorRetrocesoFinal < objetivo) {
        this.mayorRetrocesoFinal = objetivo;
      }
    }

    this.enforcePasoRetrocesoMin();
  }

  onMayorRetrocesoBlur(): void {
    this.mayorRetrocesoObjetivo = this.convertirValorNumerico(this.mayorRetrocesoObjetivo);
    if (this.habilitarRangoRetroceso && this.mayorRetrocesoObjetivo !== null) {
      if (this.mayorRetrocesoFinal === null || this.mayorRetrocesoFinal < this.mayorRetrocesoObjetivo) {
        this.mayorRetrocesoFinal = this.mayorRetrocesoObjetivo;
      }
    }

    this.enforcePasoRetrocesoMin();
  }

  onMayorRetrocesoFinalBlur(): void {
    this.mayorRetrocesoFinal = this.convertirValorNumerico(this.mayorRetrocesoFinal);
    if (this.habilitarRangoRetroceso && this.mayorRetrocesoObjetivo !== null && this.mayorRetrocesoFinal !== null) {
      if (this.mayorRetrocesoFinal < this.mayorRetrocesoObjetivo) {
        this.mayorRetrocesoFinal = this.mayorRetrocesoObjetivo;
      }
    }

    this.enforcePasoRetrocesoMin();
  }

  onPasoRetrocesoBlur(): void {
    this.pasoRetroceso = this.convertirValorNumerico(this.pasoRetroceso);
    this.enforcePasoRetrocesoMin();
  }
  ngOnInit(): void {
    this.token = this.cookieService.get('auth_token');
    this.metaapiConnected = !!this.metaApiService.getToken();
    this.metaApiService.connected$.subscribe(val => { this.metaapiConnected = val; });
    this.setupFilters();
    // Cargar datos del menú/indicadores y condiciones
    this.fetchMenuData();
    // Inicializar como null explícitamente
    this.tasaCompuestaObjetivo = 10;
    this.mayorRetrocesoObjetivo = 40;
    this.maxcombinaciones = 4;
    this.apiService.apiPost("listamercados", true, {}, 2).then((response) => {
      if (response.data) {
        this.mercados = response.data;
      }
      // this.listarCompanias();
    });
    this.planificadorsv.loadIndicatorTypes()
      .then((res: any) => {
        this.allIndicatorTypes = res.data;
        this.indicatorsIa = this.allIndicatorTypes.indicadoresIA;
        this.condicionesIa = this.allIndicatorTypes.condicionesIa;
        this.planificadorsv.indicatorsIaSinEspacios = this.indicatorsIa.map(el => el.replace(' ', '_'));
        console.log('Indicadores IA cargados:', this.indicatorsIa);
        this.frecuencySelect = res.data.periodos || [];
      });
    // Sync dark mode with OS preference

    this.subtema = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
      }
    });

    // Restaurar anchos persistidos
    setTimeout(() => this.restoreSavedWidths?.(), 60);

    // Load configuration from query parameters if provided
    this.route.queryParams.subscribe(params => {
      console.log('🔍 Query params recibidos:', params);
      if (params['idModelo']) {
        this.idModelo = Number(params['idModelo']);
        console.log('✅ idModelo detectado:', this.idModelo);
        console.log('📦 Todos los params:', params);
        this.combinaciones = false;
        
        // Cargar datos del modelo desde la API
        console.log('🌐 Llamando a API: parametrosmodelo?idmodelo=' + this.idModelo);
        this.apisseservice.apiGetNew('parametrosmodelo?idmodelo=' + this.idModelo).subscribe({
          next: (data: any) => {
            console.log('📥 Respuesta de API recibida:', data);
            console.log('📥 Tipo de data:', typeof data);
            console.log('📥 data.condicionln existe?:', !!data?.condicionln);
            
            if (data && data.condicionln) {
              console.log('✅ Datos del modelo cargados:', data);
              console.log('📝 condicionln (raw):', data.condicionln);
              const condicionln = JSON.parse(data.condicionln);
              console.log('📝 condicionln (parsed):', condicionln);
              
              // Rellenar fecha inicial
              if (condicionln.start) {
                this.fechaInicial = condicionln.start;
                console.log('📅 fechaInicial asignada:', this.fechaInicial);
              }
              
              // Rellenar stop loss (convertir string a number)
              if (condicionln.stopLoss !== undefined) {
                this.stopLossValue = Number(condicionln.stopLoss);
                this.stopLossValueFinal = this.stopLossValue; // Asignar el mismo valor al rango final para mantener consistencia
              }
              if (condicionln.stopLossActivo !== undefined) {
                this.stopLoss = condicionln.stopLossActivo;
              }
              if (condicionln.stopLossDinamicActivo !== undefined) {
                this.stopLossDinamico = condicionln.stopLossDinamicActivo;
              }
              
              // Rellenar profit (convertir string a number)
              if (condicionln.profit !== undefined) {
                this.proFitValue = Number(condicionln.profit);
                console.log('💰 proFitValue asignado:', this.proFitValue);
              }
              if (condicionln.proFitActivo !== undefined) {
                this.proFit = condicionln.proFitActivo;
              }
              
              // Rellenar dias salida
              if (condicionln.diasSalida !== undefined) {
                this.diasSalidaValue = Number(condicionln.diasSalida);
              }
              if (condicionln.diasSalidaActivo !== undefined) {
                this.diasSalida = condicionln.diasSalidaActivo;
              }

              // Rellenar salida fin de día
              if (condicionln.salidaFinDiaActivo !== undefined) {
                this.salidaFinDiaActivo = condicionln.salidaFinDiaActivo;
              }

              // Rellenar bajista
              if (condicionln.bajista !== undefined) {
                this.optimalWallet.bajista = condicionln.bajista;
              }
              
              console.log('Campos rellenados desde modelo:', {
                fechaInicial: this.fechaInicial,
                stopLoss: this.stopLossValue,
                stopLossActivo: this.stopLoss,
                stopLossDinamico: this.stopLossDinamico,
                profit: this.proFitValue,
                proFitActivo: this.proFit,
                diasSalida: this.diasSalidaValue,
                diasSalidaActivo: this.diasSalida,
                salidaFinDiaActivo: this.salidaFinDiaActivo,
                bajista: this.optimalWallet.bajista
              });
              
              // Forzar detección de cambios
              this.cdr.detectChanges();
              
              // Sobrescribir con query params si existen (tienen prioridad)
              if (params['fechaInicio']) {
                this.fechaInicial = params['fechaInicio'];
              }
            //  if (params['stopLoss']) {
              //  this.stopLossValue = Number(params['stopLoss']);
             // }
             // if (params['stopLossActivo']) {
             //   this.stopLoss = params['stopLossActivo'] === 'true';
              //}
              //if (params['stopLossDinamicActivo']) {
               // this.stopLossDinamico = params['stopLossDinamicActivo'] === 'true';
              //}
              //if (params['profit']) {
               // this.proFitValue = Number(params['profit']);
             // }
              //if (params['proFitActivo']) {
               // this.proFit = params['proFitActivo'] === 'true';
              //}
              //if (params['diasSalida']) {
                //this.diasSalidaValue = Number(params['diasSalida']);
             // }
             // if (params['diasSalidaActivo']) {
              //  this.diasSalida = params['diasSalidaActivo'] === 'true';
              //}
              
              // Load model and market configuration from query params (after loading from model)
              if (params['idMercado']) {
                this.selectedIdMercado = Number(params['idMercado']);
              }
              
              // Load portfolio configuration
              if (params['capitalInicial']) {
                this.capitalInicial = Number(params['capitalInicial']);
                this.optimalWallet.capitalinicial = this.capitalInicial;
              }
              if (params['tipoCuenta']) {
                this.tipoCuenta = params['tipoCuenta'];
                this.optimalWallet.tipocuenta = this.tipoCuenta;
              }
              if (params['riesgo']) {
                this.valorRiesgo = Number(params['riesgo']);
                this.optimalWallet.riesgo = this.valorRiesgo;
              }
              if (params['tipoRiesgo']) {
                this.selectedTipoRiesgo = params['tipoRiesgo'];
                this.optimalWallet.tiporiesgo = this.selectedTipoRiesgo;
              }
              
              if (params['margenRequerido']) {
                this.margenRequeridoPor = Number(params['margenRequerido']);
                this.optimalWallet.margenRequeridoPor = this.margenRequeridoPor;
              }
              if (params['controlMarginCall']) {
                this.controlMarginCall = Number(params['controlMarginCall']);
                this.optimalWallet.controlMarginCall = this.controlMarginCall;
              }
              if (params['riesgoMaximo']) {
                this.riesgoMaximo = Number(params['riesgoMaximo']);
                this.optimalWallet.riesgomaximo = this.riesgoMaximo;
              }
              if (params['bajista']) {
                this.optimalWallet.bajista = params['bajista'] === 'true';
              }
              // La URL refleja el estado actual del toggle en /models: tiene prioridad sobre el modelo
              if (params['salidaFinDiaActivo'] !== undefined) {
                this.salidaFinDiaActivo = params['salidaFinDiaActivo'] === 'true';
              }
              // Comisión y gastos de /models: se comprueba presencia y no truthy, porque 0/false son válidos
              if (params['comisionbroker'] !== undefined && params['comisionbroker'] !== '') {
                this.optimalWallet.comisionbroker = Number(params['comisionbroker']);
              }
              if (params['gastosGestionPor'] !== undefined && params['gastosGestionPor'] !== '') {
                this.optimalWallet.gastosGestionPor = Number(params['gastosGestionPor']);
              }
              if (params['gastosPrestamoPor'] !== undefined && params['gastosPrestamoPor'] !== '') {
                this.optimalWallet.gastosPrestamoPor = Number(params['gastosPrestamoPor']);
              }
              if (params['chkcomisionbroker'] !== undefined) {
                this.optimalWallet.chkcomisionbroker = params['chkcomisionbroker'] === 'true';
              }
              if (params['chkgastogest'] !== undefined) {
                this.optimalWallet.chkgastogest = params['chkgastogest'] === 'true';
              }
              if (params['chkgastoprest'] !== undefined) {
                this.optimalWallet.chkgastoprest = params['chkgastoprest'] === 'true';
              }
              if (params['periodo']) {
                this.selectedFrecuency = Number(params['periodo']);
              }

              // Recalcular el piso de fechas (min del input) para el mercado/periodo del modelo,
              // sin alterar la fechaInicial que llega controlada desde /models.
              this.checkAndUpdateFechaInicial(true);

              // Forzar detección de cambios después de sobrescribir con query params
              this.cdr.detectChanges();

              this.toastr.success(`Configuración del modelo ${params['idModelo']} cargada`, 'Modelo Cargado');
              
              // Ejecutar automáticamente idpaso=0 cuando se carga un modelo desde la URL
              setTimeout(() => {
                this.buscarAlgoritmo(1, 0);
              }, 500);
            } else {
              console.warn('⚠️ La respuesta no contiene condicionln');
              console.warn('⚠️ Estructura de data recibida:', JSON.stringify(data, null, 2));
              this.toastr.error('La respuesta del modelo no tiene el formato esperado', 'Advertencia');
            }
          },
          error: (error) => {
            console.error('❌ Error cargando datos del modelo:', error);
            console.error('❌ Detalles del error:', {
              status: error.status,
              statusText: error.statusText,
              message: error.message,
              error: error.error
            });
            this.toastr.error('No se pudieron cargar los datos del modelo', 'Error');
          }
        });
      } else {
        console.log('⚠️ No se encontró idModelo en query params');
        // Cargar la fecha inicial real disponible para el mercado por defecto
        this.checkAndUpdateFechaInicial();
      }
    });
  }

  private fetchMenuData(): void {
    this.loadingIndicadoresCondiciones = true;
    this.error = null;

    this.menuService.getMenuData().subscribe({
      next: (data: MenuItem[]) => {
        this.menuData = data;
        this.loadConditions();
        this.loadingIndicadoresCondiciones = false;
      },
      error: (error: Error) => {
        console.error('Error fetching menu data:', error);
        this.error = 'Error cargando los datos';
        this.loadingIndicadoresCondiciones = false;
      }
    });
  }

  private setupFilters() {
    // Condiciones ya no usa MatTableDataSource: el filtro se aplica manualmente
    // (ver filterAndSortIndicadores / refreshCondicionesDataSource).
  }

  // CdkTableVirtualScrollDataSource no trae filtrado/orden de MatTableDataSource;
  // se aplica manualmente sobre la lista completa y se reasigna a dataSource.data
  private filterAndSortIndicadores(all: Condition[], filterValue: string, sortColumn: 'label' | 'action' | null, sortDirection: 'asc' | 'desc'): Condition[] {
    const filter = (filterValue || '').trim().toLowerCase();
    let result = filter ? all.filter(item => item.label.toLowerCase().includes(filter)) : [...all];

    if (sortColumn) {
      const dir = sortDirection === 'asc' ? 1 : -1;
      result = result.sort((a, b) => {
        const comparison = sortColumn === 'label'
          ? a.label.localeCompare(b.label)
          : (+a.action || 0) - (+b.action || 0);
        return comparison * dir;
      });
    }
    return result;
  }

  // Fuente única de condiciones cargadas; dataSource.data siempre se deriva de acá
  // filtrada/ordenada, igual que en las tablas de indicadores.
  private setCondicionesData(data: Condition[]): void {
    this.allCondiciones = data;
    this.refreshCondicionesDataSource();
  }

  private refreshCondicionesDataSource(): void {
    this.condicionesDataSource.data = this.filterAndSortIndicadores(this.allCondiciones, this.condicionesFilterValue, this.sortColumnCondiciones, this.sortDirectionCondiciones);
  }

  showTab(tab: any) {
    if (tab == 'cartera') {
      console.log(tab);
      this.cartera = !this.cartera;
      localStorage.setItem('strategyfactory_panel_cartera', String(this.cartera));
    } else {
      this.modeloDiv = !this.modeloDiv;
      localStorage.setItem('strategyfactory_panel_modeloDiv', String(this.modeloDiv));
    }
  }

  // Método para convertir y depurar los valores de los parámetros
  convertirValorNumerico(valor: any): number | null {
    if (valor === null || valor === undefined || valor === '') {
      return null;
    }

    const numeroConvertido = Number(valor);
    return !isNaN(numeroConvertido) ? numeroConvertido : null;
  }

  get pasoRiesgoMin(): number {
    return 1; // Mínimo siempre es 1
  }

  onPasoRiesgoBlur(): void {
    this.pasoRiesgo = this.convertirValorNumerico(this.pasoRiesgo);
    this.enforcePasoRiesgoMin();
  }

  get pasoRiesgoMax(): number {
    return 10000; // Un máximo razonable por defecto
  }

  get pasoRiesgoStep(): number {
    return 1; // Paso siempre de 1
  }

  private obtenerRangoRiesgo(): number | null {
    if (!this.habilitarRangoRiesgo) {
      return null;
    }

    const valorInicial = this.convertirValorNumerico(this.valorRiesgo);
    const valorFinal = this.convertirValorNumerico(this.valorRiesgoFinal);

    if (valorInicial === null || valorFinal === null) {
      return null;
    }

    const diferencia = Math.abs(valorFinal - valorInicial);
    return diferencia > 0 ? diferencia : null;
  }

  private enforcePasoRiesgoMin(): void {
    console.log('DEBUG: enforcePasoRiesgoMin llamada');
    if (!this.habilitarRangoRiesgo) {
      return;
    }

    const min = 1;
    const max = 10000;
    const pasoRiesgoValue = this.convertirValorNumerico(this.pasoRiesgo);

    if (pasoRiesgoValue === null || pasoRiesgoValue < min) {
      this.pasoRiesgo = min;
      return;
    }

    if (pasoRiesgoValue > max) {
      this.pasoRiesgo = max;
    }
  }

  get pasoStopLossMin(): number {
    return 0.1;
  }

  get pasoStopLossMax(): number {
    return 100;
  }

  get pasoStopLossStep(): number {
    return 0.1;
  }

  private obtenerRangoStopLoss(): number | null {
    if (!this.stopLoss || !this.habilitarRangoStopLoss) {
      return null;
    }

    const valorInicial = this.convertirValorNumerico(this.stopLossValue);
    const valorFinal = this.convertirValorNumerico(this.stopLossValueFinal);

    if (valorInicial === null || valorFinal === null) {
      return null;
    }

    const diferencia = Math.abs(valorFinal - valorInicial);
    return diferencia > 0 ? diferencia : null;
  }

  private enforcePasoStopLossMin(): void {
    console.log('DEBUG: enforcePasoStopLossMin llamada');
    if (!this.stopLoss || !this.habilitarRangoStopLoss) {
      return;
    }

    const min = 0.1;
    const max = 100;
    const pasoValue = this.convertirValorNumerico(this.pasoStopLossValue);

    if (pasoValue === null || pasoValue < min) {
      this.pasoStopLossValue = min;
      return;
    }

    if (pasoValue > max) {
      this.pasoStopLossValue = max;
    }
  }

  get pasoRetrocesoMin(): number {
    return 0.01;
  }

  get pasoRetrocesoMax(): number {
    return 100;
  }

  get pasoRetrocesoStep(): number {
    return 0.01;
  }

  private obtenerRangoRetroceso(): number | null {
    if (!this.habilitarRangoRetroceso) {
      return null;
    }

    const valorInicial = this.convertirValorNumerico(this.mayorRetrocesoObjetivo);
    const valorFinal = this.convertirValorNumerico(this.mayorRetrocesoFinal);

    if (valorInicial === null || valorFinal === null) {
      return null;
    }

    const diferencia = Math.abs(valorFinal - valorInicial);
    return diferencia > 0 ? diferencia : null;
  }

  private enforcePasoRetrocesoMin(): void {
    console.log('DEBUG: enforcePasoRetrocesoMin llamada');
    if (!this.habilitarRangoRetroceso) {
      return;
    }

    const min = 0.01;
    const max = 100;
    const pasoRetrocesoValue = this.convertirValorNumerico(this.pasoRetroceso);

    if (pasoRetrocesoValue === null || pasoRetrocesoValue < min) {
      this.pasoRetroceso = min;
      return;
    }

    if (pasoRetrocesoValue > max) {
      this.pasoRetroceso = max;
    }
  }

  private calcularPasoBase(diferencia: number): number {
    if (diferencia >= 1000) {
      return 100;
    }
    if (diferencia >= 200) {
      return 50;
    }
    if (diferencia >= 100) {
      return 10;
    }
    if (diferencia >= 1) {
      return 1;
    }
    if (diferencia > 0.1) {
      return 0.1;
    }
    return 0.01;
  }

  /**
   * Inicia o cancela la búsqueda de algoritmos según los parámetros configurados
   * 
   * Esta función es responsable de ejecutar diferentes tipos de búsquedas de algoritmos:
   * - Búsqueda inicial de condiciones (idpaso=1)
   * - Optimización de condiciones seleccionadas (idpaso=2)
   * 
   * El método gestiona las suscripciones a eventos SSE (Server-Sent Events) para recibir
   * actualizaciones en tiempo real sobre el progreso de la búsqueda y los resultados.
   * 
   * @param idpaso - Identificador del paso a ejecutar: 
   *                 1: Búsqueda inicial de condiciones
   *                 2: Optimización de una condición seleccionada
   *                 
   * @param modo - Modo de optimización: 
   *               0: Optimización genética
   *               1: Optimización por fuerza bruta
   * @param result - (Opcional) Resultado seleccionado para optimizar en el paso 2
   * 
   * 
   * @returns void - No retorna valores, actualiza el estado interno del componente y
   *                 gestiona las suscripciones a eventos SSE
   */
  buscarAlgoritmo(idpaso: number, modo: number, result?: ResultItem | null): void {
    if (idpaso === 1 && !this.loading && this.results.topResults.length > 0) {
      const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
      this.dialog.open(DialogConfirmacionComponent, {
        width: '380px',
        panelClass: dialogClass,
        data: {
          titulo: 'Nueva ejecución',
          mensaje: 'Se eliminarán todos los modelos generados en la ejecución anterior. ¿Desea continuar?',
          botonConfirmar: 'Ejecutar',
          botonCancelar: 'Cancelar'
        }
      }).afterClosed().subscribe(confirmed => { if (confirmed) this._buscarAlgoritmo(idpaso, modo, result); });
      return;
    }
    this._buscarAlgoritmo(idpaso, modo, result);
  }

  private _buscarAlgoritmo(idpaso: number, modo: number, result?: ResultItem | null): void {

    if (idpaso === 1 && this.buscarmetaapi(this.selectedIdMercado) && !this.metaapiConnected) {
      this.toastr.error('Se necesita conectarse al broker para usar datos MetaApi.');
      this.openBrokerLogin();
      return;
    }

    const idgroup = result?.group ?? 0;
    const maxDrawdown = result?.maxDrawdown ?? 0;
    const compoundRate = result?.compoundRate ?? 0;
    if (idpaso == 1 && this.selectionTecnicos.selected.length == 0 && this.selectionRatios.selected.length == 0 && this.selectionListas.selected.length == 0 && this.selectionPatrones.selected.length == 0 && this.selectionCondiciones.selected.length == 0 && this.idModelo == 0) {
      this.toastr.error('Seleccione al menos una condición para la búsqueda');
      return;
    }
    if (this.selectedIdMercado == null || this.selectedIdMercado == undefined || this.selectedIdMercado == 0) {
      this.toastr.error('Seleccione un mercado');
      return;
    }
    // idindicadores: IDs de los indicadores seleccionados (Técnicos, Ratios, Listas, Patrones)
    // Se excluyen los que están en estado indeterminate (selección parcial de condiciones):
    // en ese caso el usuario quiere condiciones específicas → van a idcondiciones vía selectionCondiciones
    this.indicadoresSeleccionados = [];
    for (const indicador of [
      ...this.selectionTecnicos.selected,
      ...this.selectionRatios.selected,
      ...this.selectionListas.selected,
      ...this.selectionPatrones.selected,
    ]) {
      const isIndeterminate =
        this.isIndicatorIndeterminate(indicador, this.selectedRowTecnico, this.selectionTecnicos) ||
        this.isIndicatorIndeterminate(indicador, this.selectedRowRatio, this.selectionRatios) ||
        this.isIndicatorIndeterminate(indicador, this.selectedRowLista, this.selectionListas) ||
        this.isIndicatorIndeterminate(indicador, this.selectedRowPatron, this.selectionPatrones);
      if (!isIndeterminate && indicador.idsList) {
        for (const id of indicador.idsList) {
          this.indicadoresSeleccionados.push(id);
        }
      }
    }

    // idcondiciones: IDs de las condiciones específicas seleccionadas en la tabla de condiciones
    this.condicionesSeleccionadas = [];
    for (const condicion of this.selectionCondiciones.selected) {
      if (condicion.idindicador) {
        this.condicionesSeleccionadas.push(condicion.idindicador);
      }
    }

    console.log('Indicadores seleccionados:', this.indicadoresSeleccionados);
    console.log('Condiciones seleccionadas:', this.condicionesSeleccionadas);
    if (idpaso == 3) {
      console.log(' paso 3 ');
      if (this.algorithmSubscriptionFinal) {
        if (this.currentJobIdFinal) {
          this.apisseservice.apiPostNew(`ia/cancelarStrategyFactoryBatch?jobId=${this.currentJobIdFinal}`, {}, this.token).subscribe();
          this.currentJobIdFinal = null;
        }
        this.algorithmSubscriptionFinal.unsubscribe();
        this.algorithmSubscriptionFinal = null;
      }
      this.detenerProcesoPrincipal();
      if (this.loadingOptimizacion) {
        if (this.algorithmSubscription3) {
          this.algorithmSubscription3.unsubscribe();
          this.algorithmSubscription3 = null;
        }
        if (this.currentJobIdOpt) {
          this.apisseservice.apiPostNew(`ia/cancelarStrategyFactoryBatch?jobId=${this.currentJobIdOpt}`, {}, this.token).subscribe();
          this.currentJobIdOpt = null;
        }

        // Cortar la conexión SSE real al cancelar
        this.apisseservice.disconnect();
        this.loadingOptimizacion = false;
        this.notificacion = 'Búsqueda cancelada';
        return;
      }
      this.loading = false;
      this.loadingOptimizacion = true;
    } else if (idpaso == 2) {
      this.detenerProcesoPrincipal();
      if (this.loadingOptimizacion) {
        if (this.algorithmSubscription3) {
          this.algorithmSubscription3.unsubscribe();
          this.algorithmSubscription3 = null;
        }
        if (this.currentJobIdOpt) {
          this.apisseservice.apiPostNew(`ia/cancelarStrategyFactoryBatch?jobId=${this.currentJobIdOpt}`, {}, this.token).subscribe();
          this.currentJobIdOpt = null;
        }

        // Cortar la conexión SSE real al cancelar
        this.apisseservice.disconnect();
        this.loadingOptimizacion = false;
        this.notificacion = 'Búsqueda cancelada';
        return;
      }
      this.loading = false;
      this.loadingOptimizacion = true;

    } else if (idpaso == 5) {
      this.selectedTab = 3;
      if (this.loadingReevaluar) {
        if (this.algorithmSubscriptionFinal) {
          this.algorithmSubscriptionFinal.unsubscribe();
          this.algorithmSubscriptionFinal = null;
        }
        if (this.currentJobIdFinal) {
          this.apisseservice.apiPostNew(`ia/cancelarStrategyFactoryBatch?jobId=${this.currentJobIdFinal}`, {}, this.token).subscribe();
          this.currentJobIdFinal = null;
        }
        this.loadingReevaluar = false;
        this.loadingOptimizacion = false;
        this.notificacion = 'Búsqueda cancelada';
        return;
      }
      this.detenerProcesoPrincipal();
      this.loadingReevaluar = true;
    } else {
      this.selectedTab = 0;

      if (this.algorithmSubscription3) {
        this.algorithmSubscription3.unsubscribe();
        this.algorithmSubscription3 = null;
      }
      if (this.loading) {
        if (this.algorithmSubscription) {
          this.algorithmSubscription.unsubscribe();
          this.algorithmSubscription = null;
        }
        if (this.algorithmSubscription2) {
          this.algorithmSubscription2.unsubscribe();
          this.algorithmSubscription2 = null;
        }

        // Notificar al backend para que detenga el proceso activo
        if (this.currentJobId) {
          this.apisseservice.apiPostNew(`ia/cancelarStrategyFactoryBatch?jobId=${this.currentJobId}`, {}, this.token).subscribe();
          this.currentJobId = null;
        }

        // Cierra todas las conexiones SSE activas (slots 0 y 1)
        this.apisseservice.disconnectAll();

        this.total = 0;
        this.pendientes = 0;
        this.completados = 0;

        this.loading = false;
        this.notificacion = 'Búsqueda cancelada';

        return;
      }

      this.loading = true;
      console.log('DEBUG: loading = true');
    }
    this.error = null;
    console.log('DEBUG: Preparando parámetros...');

    // Convertir los valores para asegurar que son números válidos
    const tasaCompuestaValue = idpaso == 2 ? this.convertirValorNumerico(compoundRate) : this.convertirValorNumerico(this.tasaCompuestaObjetivo);
    const mayorRetrocesoValue = idpaso == 2 ? this.convertirValorNumerico(maxDrawdown) : this.convertirValorNumerico(this.mayorRetrocesoObjetivo);
    const maxcombinacionesValue = this.convertirValorNumerico(this.maxcombinaciones);
    const start = this.fechaInicial;
    const end = this.fechaFinal;


    // Añadir parámetros como query parameters
    const params: string[] = [];
    const setParamValue = (key: string, value: string | number | boolean | null | undefined) => {
      if (value === null || value === undefined) {
        return;
      }

      const prefix = `${key}=`;
      const normalizedValue = `${value}`;
      const existingIndex = params.findIndex(param => param.startsWith(prefix));

      if (existingIndex !== -1) {
        params[existingIndex] = `${prefix}${normalizedValue}`;
        return;
      }

      params.push(`${prefix}${normalizedValue}`);
    };
    if (tasaCompuestaValue !== null) {
      params.push(`tasaCompuestaObjetivo=${tasaCompuestaValue}`);
    }

    if (mayorRetrocesoValue !== null) {
      params.push(`mayorRetrocesoObjetivo=${mayorRetrocesoValue}`);
    }

    if (maxcombinacionesValue !== null) {
      params.push(`maxcombinaciones=${maxcombinacionesValue}`);
    }

    const minimoOperacionesValue = this.convertirValorNumerico(this.minimoOperaciones);
    if (minimoOperacionesValue !== null) {
      params.push(`minimoOperaciones=${minimoOperacionesValue}`);
    }
    params.push(`start=${start}`);
    params.push(`end=${end}`); // Este valor es para simular la disponibilidad de la API
    params.push(`idMercado=${this.selectedIdMercado}`); // Este valor es para simular la disponibilidad de la API
    params.push(`periodo=${this.selectedFrecuency}`);
    params.push(`metaapi=${this.buscarmetaapi(this.selectedIdMercado)}`); // Este valor es para simular la disponibilidad de la API
    params.push(`stopLoss=${this.stopLossValue}`); // Este valor es para simular la disponibilidad de la API
    params.push(`capitalInicial=${this.capitalInicial}`); // Este valor es para simular la disponibilidad de la API
    //agregar tipoCuenta, margenRequeridoPor, controlMargenCall y riesgomaximo
    params.push(`tipoCuenta=${this.tipoCuenta}`); // Este valor es para simular la disponibilidad de la API
    params.push(`margenRequeridoPor=${this.margenRequeridoPor}`); // Este valor es para simular la disponibilidad de la API
    params.push(`controlMarginCall=${this.controlMarginCall}`); // Este valor es para simular la disponibilidad de la API
    params.push(`riesgoMaximo=${this.riesgoMaximo}`); // Este valor es para simular la disponibilidad de la API
    // Los tres costes se envían solo si su toggle está activo; desactivado equivale a 0,
    // que es el default del backend y deja el backtest como si no existiera el coste.
    params.push(`comisionBroker=${this.costeActivo(this.optimalWallet.chkcomisionbroker, this.optimalWallet.comisionbroker)}`);
    params.push(`gastosGestionPor=${this.costeActivo(this.optimalWallet.chkgastogest, this.optimalWallet.gastosGestionPor)}`);
    params.push(`gastosPrestamoPor=${this.costeActivo(this.optimalWallet.chkgastoprest, this.optimalWallet.gastosPrestamoPor)}`);
    const valorRiesgoValue = this.convertirValorNumerico(this.valorRiesgo);
    if (valorRiesgoValue !== null) {
      params.push(`valorRiesgo=${valorRiesgoValue}`);
    }
    //if (this.habilitarRangoRiesgo) {
    let valorRiesgoFinalValue = this.convertirValorNumerico(this.valorRiesgoFinal);

    if (valorRiesgoValue !== null && valorRiesgoFinalValue !== null && valorRiesgoFinalValue < valorRiesgoValue) {
      valorRiesgoFinalValue = valorRiesgoValue;
      this.valorRiesgoFinal = valorRiesgoValue;
    }

    this.enforcePasoRiesgoMin();
    const pasoRiesgoValue = this.convertirValorNumerico(this.pasoRiesgo);

    if (valorRiesgoFinalValue !== null) {
      params.push(`valorRiesgoFinal=${valorRiesgoFinalValue}`);
    }

    if (pasoRiesgoValue !== null) {
      params.push(`pasoRiesgo=${pasoRiesgoValue}`);
    }
    params.push(`fracciones=${this.fracciones}`);
    //
    params.push(`fechaInicialReevaluar=${this.fechaInicialReevaluar}`); // Este valor es para simular la disponibilidad de la API
    params.push(`fechaFinalReevaluar=${this.fechaFinalReevaluar}`); // Este valor es para simular la disponibilidad de la API
    //params para optimizaciones 

    const mayorRetrocesoBaseProp = this.convertirValorNumerico(this.mayorRetrocesoObjetivo);
    const mayorRetrocesoBase = mayorRetrocesoBaseProp !== null ? mayorRetrocesoBaseProp : mayorRetrocesoValue;
    if (this.mayorRetrocesoObjetivo === null && mayorRetrocesoBase !== null) {
      this.mayorRetrocesoObjetivo = mayorRetrocesoBase;
    }

    let mayorRetrocesoFinalValue = this.convertirValorNumerico(this.mayorRetrocesoFinal);
    if (mayorRetrocesoBase !== null) {
      if (mayorRetrocesoFinalValue === null || mayorRetrocesoFinalValue < mayorRetrocesoBase) {
        mayorRetrocesoFinalValue = mayorRetrocesoBase;
        this.mayorRetrocesoFinal = mayorRetrocesoBase;
      }
    }

    this.enforcePasoRetrocesoMin();
    mayorRetrocesoFinalValue = this.convertirValorNumerico(this.mayorRetrocesoFinal);
    const pasoRetrocesoValue = this.convertirValorNumerico(this.pasoRetroceso);

    if (mayorRetrocesoFinalValue !== null) {
      params.push(`mayorRetrocesoFinal=${mayorRetrocesoFinalValue}`);
    }

    if (pasoRetrocesoValue !== null) {
      params.push(`pasoRetroceso=${pasoRetrocesoValue}`);
    }

    params.push(`idindicadores=${this.indicadoresSeleccionados}`);
    params.push(`idcondiciones=${this.condicionesSeleccionadas}`);
    params.push(`sectype=${this.sectype}`); // Este valor es para simular la disponibilidad de la API
    params.push(`stopLossActivo=${this.stopLoss}`); // Este valor es para simular la disponibilidad de la API
    params.push(`stopLossDinamico=${this.stopLossDinamico}`); // Este valor es para simular la disponibilidad de la API
    const stopLossBase = this.convertirValorNumerico(this.stopLossValue);
    let stopLossFinalValue = this.convertirValorNumerico(this.stopLossValueFinal);

    if (stopLossBase !== null) {
      if (stopLossFinalValue === null || stopLossFinalValue < stopLossBase) {
        stopLossFinalValue = stopLossBase;
        this.stopLossValueFinal = stopLossBase;
      }
    }

    this.enforcePasoStopLossMin();
    stopLossFinalValue = this.convertirValorNumerico(this.stopLossValueFinal);
    const pasoStopLossValue = this.convertirValorNumerico(this.pasoStopLossValue);

    if (stopLossFinalValue !== null) {
      params.push(`stopLossFinal=${stopLossFinalValue}`);
    }

    if (pasoStopLossValue !== null) {
      params.push(`pasoStopLoss=${pasoStopLossValue}`);
    }

    params.push(`proFitActivo=${this.proFit}`); // Este valor es para simular
    params.push(`proFit=${this.proFitValue}`); // Este valor es para simular la disponibilidad de la API
    params.push(`diasSalida=${this.diasSalidaValue}`); // Este valor es para simular la disponibilidad de la API
    params.push(`diasSalidaActivo=${this.diasSalida}`); // Este valor es para simular la disponibilidad de la API
    params.push(`salidaFinDiaActivo=${this.salidaFinDiaActivo}`);
    params.push(`bajista=${this.optimalWallet.bajista}`); // Este valor es para simular la disponibilidad de la API
    params.push(`optimizarCondicionData=${encodeURIComponent(JSON.stringify(this.optimizarCondicionData))}`); // Este valor es para simular la disponibilidad de la API
    params.push(`tipoRiesgo=${this.selectedTipoRiesgo}`); // Este valor es para simular la disponibilidad de la API
    params.push(`licencia=${this.token}`); // Este valor es para simular la disponibilidad de la API
    let reevaluarIds: number[] = [];
    let reevaluarRiesgos: number[] = [];
    for (let i = 0; i < this.selectionReevaluar.selected.length; i++) {
      let condicion = this.selectionReevaluar.selected[i];
      if (condicion.group) {
        reevaluarIds.push(condicion.group);
      }
      if (condicion.valorriesgo) {
        reevaluarRiesgos.push(condicion.valorriesgo);
      }
    }
    //    let stringreevaluarIds = reevaluarIds.join(',');
    params.push(`reevaluarIds=${reevaluarIds.join(',')}`); // Este valor es para simular la disponibilidad de la API
    params.push(`reevaluarRiesgos=${reevaluarRiesgos.join(',')}`); // Este valor es para simular la disponibilidad de la API
    params.push(`idModelo=${this.idModelo}`); // Este valor es para simular la disponibilidad de la API
    // Headers básicos
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    if (idpaso != 1) {
      //cambiar params stopLoss, stopLossFinal, pasoStopLoss, valorRiesgo, valorRiesgoFinal, pasoRiesgo, mayorRetrocesoFinal, pasoRetroceso, mayorRetrocesoObjetivo, fracciones por los valores de result 

      setParamValue('stopLoss', result?.stopLoss ?? 0);
      setParamValue('stopLossFinal', result?.stopLoss ?? 0);
      setParamValue('pasoStopLoss', 0);
      setParamValue('valorRiesgo', result?.valorriesgo ?? 0);
      setParamValue('valorRiesgoFinal', result?.valorriesgo ?? 0);
      setParamValue('pasoRiesgo', 0);
      setParamValue('mayorRetrocesoFinal', result?.maxDrawdownObjetivo ?? 0);
      setParamValue('pasoRetroceso', 0);
      setParamValue('mayorRetrocesoObjetivo', result?.maxDrawdownObjetivo ?? 0);
      setParamValue('fracciones', result?.fracciones ?? false);
    }
    if (idpaso == 1) {
      console.log(' paso 1 ');
      let contador = 0;
      let iniciadocombinacion = false;
      this.validas = 0;
      this.omitidas = 0;
      this.descartadasPorOperaciones = 0;
      this.resultadosTemporal = [];
      this.metricsPorClave.clear();
      this.results = this.mockData;
      this.results.topResults = []; // Inicializar el array de resultados
      this.results.topResultsOptimizado = []; // Inicializar el array de resultados optimizados
      this.results.topResultsOptimizado2 = []; // Inicializar el array de resultados optimizados
      this.results.topResultsOptimizado3 = []; // Inicializar el array de resultados optimizados
      this.results.topResultsOptimizado4 = []; // Inicializar el array de resultados optimizados
      this.results.topResultsReevaluacion = []; // Inicializar el array de resultados optimizados
      this.results.seleccionado = []; // Inicializar el array de resultados optimizados
      this.results.seleccionado2 = []; // Inicializar el array de resultados optimizados
      this.results.seleccionado3 = []; // Inicializar el array de resultados optimizados
      this.results.seleccionado4 = []; // Inicializar el array de resultados optimizados
      this.results.seleccionadoReevaluacion = []; // Inicializar el array de resultados optimizados
      this.total = 0;
      this.pendientes = 0;
      this.completados = 0;
      this.totalCombinacion = 0;
      this.pendientesCombinacion = 0;
      this.completadosCombinacion = 0;
      this.totalgeneral = 0;
      this.pendientesgeneral = 0;
      this.completadosgeneral = 0;
      this.validasOptimizadas = 0;
      this.omitidasOptimizadas = 0;
      this.notificacion = '';
      this.clearSelectionReevaluar();
      // Generar jobId único para poder cancelar el proceso en el backend
      this.currentJobId = `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
      params.push(`jobId=${this.currentJobId}`);
      // Store the subscription
      console.log('DEBUG: Antes de llamar SSE');
      console.log('DEBUG: params=', params.join('&'));
      this.algorithmSubscription = this.apisseservice.apiGetSse2(`ia/strategyfactorybatch?${params.join('&')}&idpaso=0`, 0).subscribe(
        {
          next: (resp: any) => {
            if (resp.name === 'batchProgress') {
              this.mostrarProgresoBatch(resp.data, this);
            }
            if (contador > 2 && iniciadocombinacion == false && this.combinaciones == true) {
              iniciadocombinacion = true;
              this.algorithmSubscription2 = this.apisseservice.apiGetSse2(`ia/strategyfactorybatch?${params.join('&')}&idpaso=1`, 1).subscribe(
                {
                  next: (resp: any) => {
                    if (resp.name === 'batchProgress') {
                      this.mostrarProgresoBatch(resp.data, this);
                    }
                    //console.log(resp.name);
                    if (resp.name === 'licencia') {
                      this.toastr.error(resp.data);
                    }
                    this.handleResponseData(resp, 2);
                  }, complete: () => {
                    this.algorithmSubscription2 = null;
                    // Solo apagar loading si idpaso=0 ya terminó también
                    if (!this.algorithmSubscription) {
                      this.loading = false;
                      this.cdr.detectChanges();
                    }
                  }
                });

            }
            if (resp.name === 'result' || resp.name === 'omitido') {
              contador++;
            }
            //console.log('nombre ' + resp.name);
            this.handleResponseData(resp, 1);

          }, complete: () => {
            this.algorithmSubscription = null;
            // Solo apagar loading si idpaso=1 (combinaciones) ya terminó o nunca arrancó
            if (!this.algorithmSubscription2) {
              this.loading = false;
              this.cdr.detectChanges();
            }
          }
        });
    } else if (idpaso == 2) {
      this.validasOptimizadas = 0;
      this.omitidasOptimizadas = 0;
      if (this.results) {
        if (this.selectedTableSource == 'main') {
          this.results.topResultsOptimizado = []; // Inicializar el array de resultados optimizados
          //if (modo == 0)
            //this.tabTitles[1] = 'Optimización Genetica'
          //else
            //this.tabTitles[1] = 'Mejora Fuerza Bruta';
        } else if (this.selectedTableSource == 'optimized') {
          this.results.topResultsOptimizado2 = []; // Inicializar el array de resultados optimizados
          //if (modo == 0)
            //this.tabTitles[2] = 'Optimización Genetica'
          //else
            //this.tabTitles[2] = 'Mejora Fuerza Bruta 2';
        } else if (this.selectedTableSource == 'optimized2') {
          //if (modo == 0)
            //this.tabTitles[3] = 'Optimización Genetica'
          //else
            //this.tabTitles[3] = 'Mejora 3 Fuerza Bruta 3';
          this.results.topResultsOptimizado3 = []; // Inicializar el array de resultados optimizados
        } else if (this.selectedTableSource == 'optimized3') {
          this.tabTitles[2] = 'Optimización Condición';
          this.results.topResultsOptimizado4 = []; // Inicializar el array de resultados optimizados
        } else if (this.selectedTableSource == 'reevaluacion') {
          this.results.topResultsReevaluacion = []; // Inicializar el array de resultados optimizados
        }
      }
      this.currentJobIdOpt = `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
      params.push(`jobId=${this.currentJobIdOpt}`);
      this.algorithmSubscription3 = this.apisseservice.apiGetSse2(`ia/strategyfactorybatch?${params.join('&')}&group=` + idgroup + `&idpaso=2&modo=` + modo, 2).subscribe(
        {
          next: (resp: any) => {
            if (resp.name === 'batchProgress') {
              this.mostrarProgresoBatch(resp.data, this);
            }
            this.handleResponseDataOptimizado(resp, this.selectedTableSource);
          }, complete: () => {
            this.loadingOptimizacion = false;
            this.loadingOptimizacion2 = false;
            this.loadingOptimizacion3 = false;
            this.loadingReevaluar = false;
            this.loadingOptimizacionFinal = false;
            this.notificacion = 'Optimización completada';
            this.algorithmSubscription3 = null;
          }
        });

    } else if (idpaso == 3) {
      this.currentJobIdFinal = `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
      params.push(`jobId=${this.currentJobIdFinal}`);
      this.algorithmSubscriptionFinal = this.apisseservice.apiGetSse2(`ia/strategyfactorybatch?${params.join('&')}&idpaso=3`, 3).subscribe(
        {
          next: (resp: any) => {
            if (resp.name === 'batchProgress') {
              this.mostrarProgresoBatch(resp.data, this);
            }
            this.handleResponseDataOptimizado(resp, 'optimized3');
          }, complete: () => {
            this.loadingOptimizacion = false;
            this.loadingOptimizacion2 = false;
            this.loadingOptimizacion3 = false;
            this.loadingReevaluar = false;
            this.loadingOptimizacionFinal = false;
            this.notificacion = 'Reoptimización completada';

            this.algorithmSubscriptionFinal = null;
          }
        });
    } else if (idpaso == 5) {
      this.currentJobIdFinal = `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
      params.push(`jobId=${this.currentJobIdFinal}`);
      // El observable de apiGetSse2 también completa cuando la conexión SSE se cae (onerror),
      // así que sin esta marca un corte se anunciaba como "Reevaluación completada" y el usuario
      // relanzaba el proceso sobre modelos que aún se estaban regenerando en el backend.
      this.reevaluacionCompletada = false;
      this.algorithmSubscriptionFinal = this.apisseservice.apiGetSse2(`ia/strategyfactorybatch?${params.join('&')}&idpaso=5`, 3).subscribe(
        {
          next: (resp: any) => {
            console.log('[Reevaluacion SSE]', resp.name, resp.data);
            if (resp.name === 'batchProgress') {
              this.mostrarProgresoBatch(resp.data, this);
            }
            if (resp.name === 'done') {
              this.reevaluacionCompletada = true;
            }
            this.handleResponseDataOptimizado(resp, 'reevaluacion');
            // EventSource corre fuera del zone de Angular → forzar CD para actualizar bindings
            this.cdr.detectChanges();
          }, complete: () => {
            this.loadingOptimizacion = false;
            this.loadingOptimizacion2 = false;
            this.loadingOptimizacion3 = false;
            this.loadingReevaluar = false;
            this.loadingOptimizacionFinal = false;
            if (this.reevaluacionCompletada) {
              this.toastr.success(`Se completó la reevaluación de ${this.selectionReevaluar.selected.length} modelo(s)`, 'Reevaluación completada');
            } else {
              this.toastr.warning('La conexión se cortó antes de terminar; los resultados mostrados están incompletos', 'Reevaluación interrumpida');
            }
            this.algorithmSubscriptionFinal = null;
            // Forzar actualización final del template y la tabla
            this.cdr.detectChanges();
            this.updateTableDataSourceForTab(300);
          }
        });
    }

  }
  private handleResponseData(resp: any, tipo: number): void {
    // si resp.name es resultado guardar en otro array. resultados 
    if (resp.name == 'resultados') {
      this.resultadosTemporal.push(resp.data);
      this.indexarMetricas(resp.data);
    }

    if (resp.name === 'result' || resp.name === 'omitido') {
      // Filtro por nº mínimo de operaciones: se descarta ANTES de entrar en topResults para
      // evitar la copia + sort del array completo que se hace en cada evento.
      if (!this.cumpleMinimoOperaciones(resp.data)) {
        this.descartadasPorOperaciones++;
        return;
      }
    }

    if (resp.name === 'result') {
      this.validas++;
      //console.log('Validas:', this.validas);
      if (this.results != null) {
        this.results.topResults = [...this.results.topResults, resp.data].sort((a, b) => {
          return a.score - b.score; // Descending order (highest score first)
        });
      } else {
        console.log('No hay resultados disponibles. handleResponseData');
      }
      this.actualizartopresults('main');
      this.updateTableDataSourceForTab(0);
    } else if (resp.name === 'omitido') {
      //console.log('Omitidas:', this.omitidas);
      this.omitidas++;
      let omitido = resp.data;
      if (omitido.type === 'Condition') {
        this.notificacion = ' Omitido: ' + omitido.condition;
      } else {
        this.notificacion = ' Omitido: ' + omitido.conditions;
      }
      if (this.results != null) {
        this.results.topResults = [...this.results.topResults, resp.data].sort((a, b) => {
          return a.score - b.score; // Descending order (highest score first)
        });
      } else {
        console.log('No hay resultados disponibles. handleResponseData');
      }
      this.actualizartopresults('main');
      this.updateTableDataSourceForTab(0);

    } else if (resp.name === 'msg') {
      this.notificacion = resp.data;
    } else if (resp.name === 'progreso') {
      //console.log('Progreso:', resp.data);
      if (tipo == 1) {
        this.pendientes = resp.data.pendientes;
        this.total = resp.data.total;
        this.completados = resp.data.completados;
      } else {
        this.pendientesCombinacion = resp.data.pendientes;
        this.totalCombinacion = resp.data.total;
        this.completadosCombinacion = resp.data.completados;
      }
      this.totalgeneral = this.total + this.totalCombinacion;
      this.pendientesgeneral = this.pendientes + this.pendientesCombinacion;
      this.completadosgeneral = this.completados + this.completadosCombinacion;
    }
  }
  /**
   * Valor de un coste (comisión / gastos) para enviar al backtest: 0 si su toggle está apagado.
   * El valor introducido se conserva en optimalWallet aunque el toggle esté off, igual que en /models.
   */
  private costeActivo(activo: boolean, valor: number | null | undefined): number {
    return activo ? (this.convertirValorNumerico(valor) ?? 0) : 0;
  }

  /**
   * Indexa unas métricas recién recibidas por la misma clave que usa actualizartopresults
   * (idModelo + valorriesgo), para poder consultarlas en O(1) al llegar el result/omitido.
   */
  private indexarMetricas(metric: Metrics): void {
    if (metric?.idModelo != null) {
      this.metricsPorClave.set(Number(metric.idModelo + '' + metric.valorriesgo), metric);
    }
  }

  /**
   * ¿El resultado llega al nº mínimo de operaciones configurado?
   * Si no se puede determinar el nº de operaciones, NO se descarta: es preferible mostrar
   * una estrategia de más que perder silenciosamente una válida.
   */
  private cumpleMinimoOperaciones(data: any): boolean {
    const minimo = this.convertirValorNumerico(this.minimoOperaciones) ?? 0;
    if (minimo <= 0) {
      return true;
    }

    const idgroup = data?.group;
    if (idgroup == null) {
      return true;
    }

    const metrics = this.metricsPorClave.get(Number(idgroup + '' + data.valorriesgo));
    const operaciones = metrics?.beneficio?.numeroOperaciones;

    return operaciones == null ? true : operaciones >= minimo;
  }

  /**
   * Actualiza las métricas detalladas de los resultados desde resultadosTemporal
   * @param source - Tabla objetivo: 'main' | 'optimized' | 'optimized2' | 'optimized3' | 'reevaluacion'
   */
  private actualizartopresults(source: 'main' | 'optimized' | 'optimized2' | 'optimized3' | 'optimized4' | 'reevaluacion' = 'main'): void {
    // Seleccionar el array objetivo según el source
    let targetArray: ResultItem[];
    //nsole.log('Actualizando top results para source:', source);
    switch (source) {
      case 'main':
        targetArray = this.results.topResults;
        break;
      case 'optimized':
        targetArray = this.results.topResultsOptimizado;
        break;
      case 'optimized2':
        targetArray = this.results.topResultsOptimizado2;
        break;
      case 'optimized3':
        targetArray = this.results.topResultsOptimizado3;
        break;
      case 'optimized4':
        targetArray = this.results.topResultsOptimizado4;
        break;
      case 'reevaluacion':
        targetArray = this.results.topResultsReevaluacion;
        break;
      default:
        console.warn(`Source desconocido: ${source}`);
        return;
    }
    //console.log('targetArray', targetArray);
    // Validar que existan datos
    if (!targetArray || targetArray.length === 0) {
      return;
    }

    if (!this.resultadosTemporal || this.resultadosTemporal.length === 0) {
      return;
    }

    // Índice ya mantenido por indexarMetricas: reconstruirlo aquí recorría todo
    // resultadosTemporal en cada evento SSE.
    const metricsMap = this.metricsPorClave;

    // Actualizar cada resultado con sus métricas correspondientes
    let actualizados = 0;
    const updatedArray = targetArray.map(result => {
      const idgroup = result?.group;

      if (idgroup == null) {
        return result;
      }

      const metrics = metricsMap.get(Number(idgroup + '' + result.valorriesgo));
   //   console.log(`Actualizando resultado ID Grupo: ${idgroup}`, metrics);
      if (metrics?.riesgos && metrics?.beneficio) {
        // Crear una copia actualizada del resultado para que OnPush detecte el cambio
        actualizados++;
        return {
          ...result,
          maxDrawdown: metrics.riesgos.retrocesoMaximoPor ?? result.maxDrawdown,
          compoundRate: metrics.beneficio.tasaAnualCompuestaPor * 100.0,
          beneficio: metrics.beneficio.beneficioNeto ?? result.beneficio,
          operaciones: metrics.beneficio.numeroOperaciones ?? result.operaciones,
          maxDrawdownValor: metrics.riesgos.retrocesoMaximo
        };
      }
      return result;
    });

    // Actualizar el array con la nueva referencia para que OnPush detecte el cambio
    switch (source) {
      case 'main':
        this.results.topResults = updatedArray;
        this.resyncSelectionByGroup();
        break;
      case 'optimized':
        this.results.topResultsOptimizado = updatedArray;
        break;
      case 'optimized2':
        this.results.topResultsOptimizado2 = updatedArray;
        break;
      case 'optimized3':
        this.results.topResultsOptimizado3 = updatedArray;
        break;
      case 'optimized4':
        this.results.topResultsOptimizado4 = updatedArray;
        break;
      case 'reevaluacion':
        this.results.topResultsReevaluacion = updatedArray;
        break;
    }

    console.log(`[${source}] Actualizados ${actualizados}/${targetArray.length} resultados con métricas detalladas`);
    
    // Forzar detección de cambios después de actualizar
    this.cdr.markForCheck();
  }
  private handleResponseDataOptimizado(resp: any, source: string): void {
    if (resp.name == 'resultados') {
      this.resultadosTemporal.push(resp.data);
      this.indexarMetricas(resp.data);
    }
    if (resp.name === 'result' || resp.name === 'omitido') {
      // Mismo filtro de seguridad que handleResponseData: sin esto, Mejora 1/2/3,
      // Optimización 2A y Reevaluación podían mostrar filas por debajo del mínimo
      // de operaciones configurado aunque la tabla principal ya las descartara.
      if (!this.cumpleMinimoOperaciones(resp.data)) {
        this.descartadasPorOperaciones++;
        return;
      }
    }
    if (resp.name === 'result') {
      this.validasOptimizadas++;
      if (this.results != null) {
        if (source == 'main') {
          this.results.topResultsOptimizado = [...this.results.topResultsOptimizado, resp.data].sort((a, b) => {
            return a.score - b.score; // Descending order (highest score first)
          });
        } else if (source == 'optimized') {
          this.results.topResultsOptimizado2 = [...this.results.topResultsOptimizado2, resp.data].sort((a, b) => {
            return a.score - b.score; // Descending order (highest score first)
          });
        } else if (source == 'optimized2') {
          this.results.topResultsOptimizado3 = [...this.results.topResultsOptimizado3, resp.data].sort((a, b) => {
            return a.score - b.score; // Descending order (highest score first)
          });
        } else if (source == 'optimized3') {
          this.results.topResultsOptimizado4 = [...this.results.topResultsOptimizado4, resp.data].sort((a, b) => {
            return a.score - b.score; // Descending order (highest score first)
          });
        } else if (source == 'reevaluacion') {
          this.results.topResultsReevaluacion = [...this.results.topResultsReevaluacion, resp.data].sort((a, b) => {
            return a.score - b.score; // Descending order (highest score first)
          });
        }
      } else {
        console.log('No hay resultados disponibles.');
      }
      let sourceopt = source;
      if (source == 'main')
        sourceopt = 'optimized';
      else if (source == 'optimized')
        sourceopt = 'optimized2';
      else if (source == 'optimized2')
        sourceopt = 'optimized3';
      else if (source == 'optimized3')
        sourceopt = 'optimized4';
      console.log(source);
      this.actualizartopresults(sourceopt as 'main' | 'optimized' | 'optimized2' | 'optimized3' | 'reevaluacion');
      this.syncTableForOptimizedSource(source);
    } else if (resp.name === 'omitido') {
      this.omitidasOptimizadas++;
      let omitido = resp.data;
      if (this.results != null) {
        if (source == 'main') {
          this.results.topResultsOptimizado = [...this.results.topResultsOptimizado, resp.data].sort((a, b) => {
            return a.score - b.score; // Descending order (highest score first)
          });
        } else if (source == 'optimized') {
          this.results.topResultsOptimizado2 = [...this.results.topResultsOptimizado2, resp.data].sort((a, b) => {
            return a.score - b.score; // Descending order (highest score first)
          });
        } else if (source == 'optimized2') {
          this.results.topResultsOptimizado3 = [...this.results.topResultsOptimizado3, resp.data].sort((a, b) => {
            return a.score - b.score; // Descending order (highest score first)
          });
        } else if (source == 'optimized3') {
          this.results.topResultsOptimizado4 = [...this.results.topResultsOptimizado4, resp.data].sort((a, b) => {
            return a.score - b.score; // Descending order (highest score first)
          });
        } else if (source == 'reevaluacion') {
          this.results.topResultsReevaluacion = [...this.results.topResultsReevaluacion, resp.data].sort((a, b) => {
            return a.score - b.score; // Descending order (highest score first)
          });
        }
      } else {
        console.log('No hay resultados disponibles.');
      }
      console.log(' source es : ' + source);
      let sourceopt = source;
      if (source == 'main')
        sourceopt = 'optimized';
      else if (source == 'optimized')
        sourceopt = 'optimized2';
      else if (source == 'optimized2')
        sourceopt = 'optimized3';
       else if (source == 'optimized3')
        sourceopt = 'optimized4';
      this.actualizartopresults(sourceopt as 'main' | 'optimized' | 'optimized2' | 'optimized3' | 'optimized4' | 'reevaluacion');
      this.syncTableForOptimizedSource(source);

      if (omitido.type === 'Condition') {
        this.notificacion = ' Omitido: ' + omitido.condition;
      } else {
        this.notificacion = ' Omitido: ' + omitido.conditions;
      }
    } else if (resp.name === 'msg') {
      this.notificacion = resp.data;
    } else if (resp.name === 'progreso') {
      // console.log('Progreso:', resp.data);
      this.pendientesOptimizacion = resp.data.pendientes;
      this.totalOptimizacion = resp.data.total;
      this.completadosOptimizacion = resp.data.completados;
      this.totalgeneral = this.total + this.totalCombinacion;
      this.pendientesgeneral = this.pendientes + this.pendientesCombinacion;
      this.completadosgeneral = this.completados + this.completadosCombinacion;
    }

  }

  // Bloquea la tecla ↑/↓ (flechas del teclado que incrementan/decrementan el segmento
  // día/mes/año enfocado en el <input type="date">) apenas el valor ya está en el límite,
  // para que el navegador ni siquiera llegue a aplicar el paso — así se evita cualquier
  // parpadeo o "giro" visible, en vez de corregirlo después de que ya se mostró.
  onFechaKeydown(event: KeyboardEvent) {
    const el = event.target as HTMLInputElement;
    if (!el.value) return;
    if (event.key === 'ArrowUp' && el.max && el.value >= el.max) {
      event.preventDefault();
    } else if (event.key === 'ArrowDown' && el.min && el.value <= el.min) {
      event.preventDefault();
    }
  }

  // Red de seguridad: corrige el valor en cada tick del spinner nativo (evento `input`,
  // cubre también el mouse-wheel y los botoncitos del spinner, que no pasan por `keydown`),
  // clampeando contra el min/max propios del elemento — para que nunca llegue a verse un
  // valor fuera de rango ni por un instante. `change` recién corrige al perder foco.
  // Se clampea al min/max del propio DOM (no al valor previamente confirmado en el modelo)
  // para que, tras girar varios pasos válidos, quede clavado en el límite y no salte atrás
  // al valor que tenía el campo antes de empezar a editar.
  onFechaInput(event: any) {
    const el = event.target;
    const ainput = el?.value;
    if (!ainput) return;
    if (el.max && ainput > el.max) {
      el.value = el.max;
    } else if (el.min && ainput < el.min) {
      el.value = el.min;
    }
  }

  changeInput(input: string, event: any) {
    var ainput = event.target?.value || event?.value || event?.checked;
    console.log(input);
    console.log(ainput);
    if (input === "fechaInicio") {
      if (ainput > this.today) {
        this.toastr.error('La fecha inicial no puede ser mayor a hoy');
        event.target.value = this.fechaInicial;
        return;
      }
      if (ainput > this.fechaFinal) {
        this.toastr.error('La fecha inicial no puede ser mayor a la fecha final');
        event.target.value = this.fechaInicial;
        return;
      }
      if (ainput < this.fechaMinimaDisponible) {
        this.toastr.error(`La fecha inicial no puede ser menor al primer dato disponible (${this.fechaMinimaDisponible})`);
        event.target.value = this.fechaInicial;
        return;
      }
      this.fechaInicial = ainput;
    } else if (input === "fechaFinal") {
      if (ainput > this.today) {
        this.toastr.error('La fecha final no puede ser mayor a hoy');
        event.target.value = this.fechaFinal;
        return;
      }
      if (ainput < this.fechaInicial) {
        this.toastr.error('La fecha final no puede ser menor a la fecha inicial');
        event.target.value = this.fechaFinal;
        return;
      }
      this.fechaFinal = ainput;
    } else if (input === 'idMercado') {
      this.sectype = this.mercados.find(m => m.idmercado === this.selectedIdMercado)?.sectype || 'STK';
      const mercado = this.mercados.find((m: any) => m.idmercado === this.selectedIdMercado);
      mercado?.metaapi ? this.margenRequeridoPor = 1 : this.margenRequeridoPor = 3;
      // El intradia ya no es exclusivo de MetaApi: en los mercados de FMP lo descarga el backend.
      if (mercado?.metaapi) {
        this.downloadMetaapiCandles(mercado);
      } else if (mercado) {
        this.downloadFmpIntradia(mercado);
      }
      this.checkAndUpdateFechaInicial();
    } else if (input === 'period') {
      const mercado = this.mercados?.find((m: any) => m.idmercado === this.selectedIdMercado);
      if (mercado?.metaapi) {
        this.downloadMetaapiCandles(mercado);
      } else if (mercado) {
        this.downloadFmpIntradia(mercado);
      }
      this.checkAndUpdateFechaInicial();
    } else if (input === 'profit') {
      this.proFitValue = ainput;
    } else if (input === 'stoploss') {
      this.stopLossValue = ainput;
    } else if (input === 'diasSalida') {
      this.diasSalidaValue = ainput;
    }
  }

  private checkAndUpdateFechaInicial(soloActualizarMinimo = false): void {
    const idmercado = this.selectedIdMercado;
    const idperiodo = this.selectedFrecuency ?? 6;
    if (!idmercado) return;

    this.apisseservice.apiPostNew('primerFechaDisponible', { idmercado, idperiodo }, this.token).subscribe({
      next: (data: any) => {
        // Piso real de fechas disponibles para este mercado/periodo (puede ser anterior o posterior al default)
        const primerDisponible = data?.fecha || this.fechaInicialDefault;
        this.fechaMinimaDisponible = primerDisponible;

        // Al cargar un modelo desde /models solo actualizamos el piso (min del input),
        // sin tocar la fechaInicial que ya viene controlada desde /models.
        if (soloActualizarMinimo) {
          // Salvaguarda ante datos inconsistentes: nunca dejar el min por encima de la fecha del modelo.
          if (this.fechaInicial && this.fechaInicial < this.fechaMinimaDisponible) {
            this.fechaMinimaDisponible = this.fechaInicial;
          }
          this.cdr.detectChanges();
          return;
        }

        // Solo empujamos fechaInicial hacia adelante si el default aún no tiene datos;
        // si hay datos desde antes del default (ej. 1990), se deja el default y el usuario puede retroceder manualmente.
        const nuevaFecha = (primerDisponible > this.fechaInicialDefault)
          ? primerDisponible
          : this.fechaInicialDefault;
        if (nuevaFecha !== this.fechaInicial) {
          this.fechaInicial = nuevaFecha;
          if (primerDisponible > this.fechaInicialDefault) {
            this.toastr.success(`Primer dato disponible: ${nuevaFecha}`, 'Fecha inicial actualizada', { timeOut: 4000 });
          }
        }
      },
      error: () => {}
    });
  }

  /**
   * Dispara en el backend la descarga intradia de FMP para el mercado y periodo elegidos.
   * El diario sigue cubierto por la descarga existente de historical-price-full.
   */
  downloadFmpIntradia(mercado: any): void {
    const periodo = Number(this.selectedFrecuency ?? 6);
    if (periodo === 6 || periodo === 8) { return; }

    // La barra no se enciende aqui sino con el primer 'simbolo': el backend solo anuncia los
    // activos que descarga de verdad, y los que el cron de 1m ya tiene al dia no llegan a mostrarla.
    this.descargaFuente = 'fmp';
    this.candlesDownloadSymbol = '';
    this.candlesDownloadBatch = 0;
    this.candlesDownloadTotal = 0;
    this.candlesDownloadExpected = 0;
    this.candlesDownloadFase = 'inicial';

    this.fmpIntradiaService.descargar(mercado.idmercado, 0, periodo).subscribe({
      next: (ev) => {
        if (ev.tipo === 'total') {
          // El progreso de FMP se cuenta por activos, no por velas: el backend descarga
          // simbolo a simbolo y no sabe de antemano cuantas velas traera cada uno.
          this.candlesDownloadExpected = Number(ev.data) || 0;
        } else if (ev.tipo === 'simbolo') {
          this.isLoadingMetaapi = true;
          this.candlesDownloadSymbol = ev.data;
          this.candlesDownloadTotal++;
        } else if (ev.tipo === 'aviso') {
          console.warn('[FMP]', ev.data);
        }
      },
      complete: () => {
        this.isLoadingMetaapi = false;
        this.candlesDownloadFase = '';
        this.descargaFuente = '';
        this.checkAndUpdateFechaInicial();
      },
      error: () => {
        this.isLoadingMetaapi = false;
        this.candlesDownloadFase = '';
        this.descargaFuente = '';
      }
    });
  }

  buscarmetaapi(idmercado: any): boolean {
    const mercado = this.mercados.find(m => m.idmercado === Number(idmercado));
    return mercado ? mercado.metaapi : false;
  }

  faseLabel(fase: MetaApiDownloadFase | ''): string {
    switch (fase) {
      case 'hueco': return 'rellenando hueco interno';
      case 'cola-antigua': return 'completando historial antiguo';
      case 'reciente': return 'actualizando datos recientes';
      case 'inicial': return 'descarga inicial';
      default: return '';
    }
  }

  truncateLabel(label: string, maxLength: number = 30): string {
    if (!label || label.length <= maxLength) {
      return label;
    }
    return label.substring(0, maxLength) + '...';
  }

  public openBrokerLogin(): void {
    const account = this.metaApiService.getAccountId();
    const dialogRef = this.dialog.open(LoginDialogComponent, {
      width: '800px', height: '600px',
      data: { metaApi: true, soloLoginMetaApi: true, cuenta: account }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.accountId) {
        this.metaapiAccountId = result.accountId;
      }
    });
  }

  private downloadOneTimeframeForCompany(
    compania: any,
    timeframe: string,
    accountId: string,
    licencia: string,
    skipSpec: boolean,
    onBatch?: (batch: number, total: number) => void,
    onTotal?: (expected: number) => void,
    onFase?: (fase: MetaApiDownloadFase) => void
  ): Observable<any> {
    const notifyFailure = (context: string) => (err: any) => {
      console.error(`[MetaAPI] ${context} (${compania.iso} ${timeframe})`, err);
      this.toastr.error(`Descarga incompleta de ${compania.iso} (${timeframe}). Se reintentará en la próxima sincronización.`, 'MetaAPI', { timeOut: 6000 });
      return EMPTY;
    };
    // Notifies the backend once MetaApi confirms it has no data before a given date, so future
    // syncs stop re-requesting the same empty range (see metaapi/historiaAgotada, metaapi/tieneCandles).
    const onExhausted = (fechaConfirmada: string) => {
      this.apisseservice.apiPostNew('metaapi/historiaAgotada', { idNectum: compania.idNectum, timeframe, fechaConfirmada }, licencia).subscribe({
        error: (err) => console.error(`[MetaAPI] Error marcando historia agotada (${compania.iso} ${timeframe})`, err)
      });
    };
    // Notifies the backend once a gap-fill pass finds nothing at the source for an internal
    // hole, so future syncs stop reporting/retrying that exact hueco.
    const onHuecoExhausted = (huecoInferior: string, huecoSuperior: string) => {
      this.apisseservice.apiPostNew('metaapi/huecoConfirmado', { idNectum: compania.idNectum, timeframe, huecoInferior, huecoSuperior }, licencia).subscribe({
        error: (err) => console.error(`[MetaAPI] Error marcando hueco confirmado (${compania.iso} ${timeframe})`, err)
      });
    };
    return this.apisseservice.apiPostNew('metaapi/tieneCandles', { idNectum: compania.idNectum, timeframe, accountId }, licencia).pipe(
      concatMap((res: any) => {
        if (res.tieneCandles) {
          // downloadMissingCandles resumes any pending gap (internal hole, incomplete
          // old-tail backfill, or the normal recent-tail gap) based on the extended
          // tieneCandles response — self-healing across interrupted downloads.
          return this.metaApiService.downloadMissingCandles(accountId, compania.iso, timeframe, res, onBatch, onTotal, onFase, onExhausted, onHuecoExhausted).pipe(
            concatMap((candles: any[]) => {
              if (!candles || candles.length === 0) return EMPTY;
              return this.apisseservice.apiPostNew('metaapi/candles', { candles, symbol: compania.iso, timeframe, idNectum: compania.idNectum }, licencia);
            }),
            catchError(notifyFailure('Error rellenando huecos de velas'))
          );
        }
        onFase?.('inicial');
        const fromDate = MetaApiService.historicalFromDate(timeframe);
        if (skipSpec) {
          return this.metaApiService.getCandlesHistorical(accountId, compania.iso, timeframe, fromDate, undefined, undefined, onBatch, onTotal, onExhausted).pipe(
            concatMap((batchCandles: any[]) => {
              if (!batchCandles || batchCandles.length === 0) return EMPTY;
              return this.apisseservice.apiPostNew('metaapi/candles', { candles: batchCandles, symbol: compania.iso, timeframe, idNectum: compania.idNectum }, licencia);
            }),
            catchError(notifyFailure('Error en descarga inicial de velas'))
          );
        }
        return this.metaApiService.getSymbolSpecification(accountId, compania.iso).pipe(
          concatMap((spec: any) => {
            if (!spec) return EMPTY;
            return from([
              this.metaApiService.getCandlesHistorical(accountId, compania.iso, timeframe, fromDate, undefined, undefined, onBatch, onTotal, onExhausted).pipe(
                concatMap((batchCandles: any[]) => {
                  if (!batchCandles || batchCandles.length === 0) return EMPTY;
                  return this.apisseservice.apiPostNew('metaapi/candles', { candles: batchCandles, symbol: compania.iso, timeframe, idNectum: compania.idNectum, contractSize: spec.contractSize }, licencia);
                }),
                catchError(notifyFailure('Error en descarga inicial de velas'))
              ),
              this.apisseservice.apiPostNew('metaapi/specificationes', { ...spec, tipoBroker: 'METAAPI' }, licencia).pipe(
                catchError(notifyFailure('Error guardando especificación de símbolo'))
              )
            ]).pipe(concatMap(obs$ => obs$));
          }),
          catchError(notifyFailure('Error obteniendo especificación de símbolo'))
        );
      }),
      catchError(notifyFailure('Error verificando estado de velas'))
    );
  }

  private downloadMetaapiCandles(mercado: any): void {
    const metaapiAccount = localStorage.getItem('metaapi_account_id') || '';
    // La cuenta pudo cambiar (aquí o en otra pestaña) con la lista ya seleccionada
    if (mercado?.metaapi_account_id && metaapiAccount && mercado.metaapi_account_id !== metaapiAccount) {
      this.toastr.warning(`La lista ${mercado.iso} pertenece a otra cuenta MetaTrader. Inicia sesión con esa cuenta para usarla.`, 'Lista no disponible');
      return;
    }
    this.metaApiService.canDownloadCandles(metaapiAccount).subscribe({
      next: (guard) => {
        if (!guard.ok) {
          this.metaapiConnected = false;
          this.toastr.error(guard.message, guard.title, { timeOut: 5000 });
          this.dialog.open(LoginDialogComponent, {
            width: '800px',
            height: '600px',
            data: { metaApi: true, soloLoginMetaApi: true, cuenta: guard.accountId || metaapiAccount }
          });
          return;
        }
        this.metaapiAccountId = guard.accountId;
        this.apisseservice.apiPostNew('buscadorCompaniasPorMercado', { idmercado: mercado.idmercado }, this.cookieService.get('auth_token')).subscribe({
          next: (data: any) => {
            if (this.metaApiService.avisarSiExcedeLimiteDescarga(data?.length ?? 0, mercado.iso)) return;
            this.descargaFuente = 'metaapi';
            this.isLoadingMetaapi = true;
            const periodoTimeframes: {[key: number]: string} = {1:'1m',2:'5m',3:'15m',4:'30m',5:'1h',6:'1d',7:'4h',8:'1w'};
            const timeframe = periodoTimeframes[Number(this.selectedFrecuency ?? 6)] ?? '1d';
            const licencia = this.cookieService.get('auth_token');
            const onBatch = (batch: number, total: number) => {
              this.candlesDownloadBatch = batch;
              this.candlesDownloadTotal = total;
            };
            const onTotal = (expected: number) => { this.candlesDownloadExpected = expected; };
            const onFase = (fase: MetaApiDownloadFase) => { this.candlesDownloadFase = fase; };
            from(data).pipe(
              concatMap((compania: any) => {
                this.candlesDownloadSymbol = compania.iso;
                this.candlesDownloadBatch = 0;
                this.candlesDownloadTotal = 0;
                this.candlesDownloadExpected = 0;
                this.candlesDownloadFase = '';
                return timer(100).pipe(
                  concatMap(() => concat(
                    this.downloadOneTimeframeForCompany(compania, timeframe, this.metaapiAccountId, licencia, false, onBatch, onTotal, onFase),
                    timeframe !== '1d'
                      ? this.downloadOneTimeframeForCompany(compania, '1d', this.metaapiAccountId, licencia, true, onBatch, onTotal, onFase)
                      : EMPTY
                  ))
                );
              })
            ).subscribe({
              complete: () => { this.isLoadingMetaapi = false; },
              error:    () => { this.isLoadingMetaapi = false; }
            });
          },
          error: () => { this.isLoadingMetaapi = false; }
        });
      }
    });
  }

  guardarPonderador(simular: boolean, modelo: any, nombre: string): void {
    console.log(modelo);
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    let name = '';
    console.log('modelo', modelo);
    if (modelo.type === 'Condition')
      name = modelo.condition.replaceAll(' ', '');
    else
      name = modelo.conditions[0].replaceAll(' ', '') + '-' + modelo.conditions[1].replaceAll(' ', '');
    name = name.replaceAll('>', '');
    name = name.replaceAll('<', '');
    name = name.replaceAll('=', '');
    name = name.replaceAll('&', '');
    name = name.replaceAll('de', '');

    const dialogRef = this.dialog.open(DialogNameComponent, {
      width: '300px',
      panelClass: dialogClass,
      data: { name: nombreCarteraConSufijo(name, simular ? '-G' : ''), maxLength: MAX_NOMBRE_CARTERA }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.optimalWallet.nombre = result;
        //        console.log("idmodelo: ", modelo);
        this.optimalWallet.idModelo = modelo.group;
        // Actualizar optimalWallet con los nuevos campos
        this.optimalWallet.tipocuenta = this.tipoCuenta;
        this.optimalWallet.margenRequeridoPor = this.margenRequeridoPor ?? 30;
        this.optimalWallet.controlMarginCall = this.controlMarginCall ?? 75;
        this.optimalWallet.riesgomaximo = this.riesgoMaximo ?? 50;
        // Comisión y gastos se guardan tal cual los dejó el usuario en el panel: son los costes
        // con los que se simuló, y la cartera debe arrancar con los mismos. Antes se forzaban a
        // 0/false, lo que hacía que la cartera ignorase costes que el backtest sí había cobrado.
        this.optimalWallet.tiporiesgo = this.selectedTipoRiesgo;
        this.optimalWallet.tipocuenta = this.tipoCuenta;
        //console.log("Guardando optima en ponderador: ",this.optimalWallet.stopLoss);//lo estoy imprimiendo
        //console.log("Guardando optima en ponderador: ",this.optimalWallet);
        let auth_token = this.cookieService.get('auth_token');
        /* aqui estmamos en guardar ponderador, alli vez el endpoint */
        //crear replica de this.optimalWallet y actualizar el campo riesgo por modelo.valorriesgo 
        var optimalWalletCopy = { ...this.optimalWallet };
        optimalWalletCopy.riesgo = modelo.valorriesgo;
        console.log('optimalWalletCopy', optimalWalletCopy);
        this.apisseservice.apiPostNew('carteraoptima/registrar', optimalWalletCopy, auth_token).subscribe({
          next: (resp: any) => {
            optimalWalletCopy.idcarteraoptima = resp.idcarteraoptima;
            this.guardarCarteraOptima(optimalWalletCopy, simular, auth_token);
          },
          error: () => {
            console.warn('No se pudo generar idcarteraoptima, se guardará la cartera sin él');
            this.guardarCarteraOptima(optimalWalletCopy, simular, auth_token);
          }
        });
      }
    });
  }

  private guardarCarteraOptima(optimalWalletCopy: any, simular: boolean, auth_token: string): void {
    this.apisseservice.apiPostNew('registrarcartera', optimalWalletCopy, auth_token).subscribe(response => {
      console.log('Response:', response);
      if (response.idcartera > 0) {
        this.toastr.success("Cartera registrada exitosamente");
        if (simular) {
          //this._gestionsv.updategestOptimaWallet(response);
          //this._routerL.navigate(['/gestor']);
        }
      } else {
        this.toastr.error(response.error);
      }
    });
  }

  parseCondition(conditionStr: string | undefined): any {
    if (!conditionStr) return {};
    try {
      return JSON.parse(conditionStr);
    } catch (e) {
      return conditionStr;
    }
  }

  getConditionText(conditionStr: string | undefined): string {
    if (!conditionStr) return '';

    try {
      const condition = JSON.parse(conditionStr);
      return `${condition.indicator} ${condition.logic_operator} ${condition.const}`;
    } catch (e) {
      return conditionStr;
    }
  }

  // Método de depuración para mostrar el tipo de dato
  getTypeOf(value: any): string {
    return typeof value;
  }

  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  sortColumnOptimizado: string = '';
  sortDirectionOptimizado: 'asc' | 'desc' = 'asc';
  sortByOptimizacion(column: string): void {
    if (this.sortColumnOptimizado === column) {
      this.sortDirectionOptimizado = this.sortDirectionOptimizado === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnOptimizado = column;
      this.sortDirectionOptimizado = 'asc';
    }
    if (this.results != null)
      this.results.topResultsOptimizado.sort((a, b) => {
        let comparison = 0;

        switch (column) {
          case 'type':
            comparison = (a.type || '').localeCompare(b.type || '');
            break;
          case 'condition':
            comparison = (a.condition || '').localeCompare(b.condition || '');
            break;
          case 'compoundRate':
            comparison = (a.compoundRate || 0) - (b.compoundRate || 0);
            break;
          case 'maxDrawdown':
            comparison = (a.maxDrawdown || 0) - (b.maxDrawdown || 0);
            break;
          case 'operaciones':
            comparison = (a.operaciones || 0) - (b.operaciones || 0);
            break;
          case 'score':
            comparison = (a.score || 0) - (b.score || 0);
            break;
          case 'tasaMDRatio':
            comparison = ((a.beneficio || 0) / Math.abs(a.maxDrawdownValor || 1)) -
              ((b.beneficio || 0) / Math.abs(b.maxDrawdownValor || 1));
            break;
        }

        return this.sortDirectionOptimizado === 'asc' ? comparison : -comparison;
      });
  }

  sortBy(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    if (this.results != null)
      this.results.topResults.sort((a, b) => {
        let comparison = 0;

        switch (column) {
          //case 'index':
          //comparison = (a.id || 0) - (b.id || 0);
          //break;
          case 'type':
            comparison = (a.type || '').localeCompare(b.type || '');
            break;
          case 'condition':
            comparison = (a.condition || '').localeCompare(b.condition || '');
            break;
          case 'compoundRate':
            comparison = (a.compoundRate || 0) - (b.compoundRate || 0);
            break;
          case 'maxDrawdown':
            comparison = (a.maxDrawdown || 0) - (b.maxDrawdown || 0);
            break;
          case 'operaciones':
            comparison = (a.operaciones || 0) - (b.operaciones || 0);
            break;
          case 'score':
            comparison = (a.score || 0) - (b.score || 0);
            break;
          case 'tasaMDRatio':
            comparison = ((a.beneficio || 0) / Math.abs(a.maxDrawdownValor || 1)) -
              ((b.beneficio || 0) / Math.abs(b.maxDrawdownValor || 1));
            break;
        }

        return this.sortDirection === 'asc' ? comparison : -comparison;
      });
  }
  onTab2Change(tab: any, event: MatTabChangeEvent): void {
    if (event.index == 1) {
      tab.selectedIndex = 0;
      window.open('/condiciones', '_blank');

    }
  }
  // Clean up on component destruction
  ngOnDestroy(): void {
    if (this.algorithmSubscription) {
      this.algorithmSubscription.unsubscribe();
    }
    if (this.algorithmSubscription2) {
      this.algorithmSubscription2.unsubscribe();
    }
    if (this.algorithmSubscription3) {
      this.algorithmSubscription3.unsubscribe();
    }
    this.apisseservice.disconnect();
    window.removeEventListener('click', this.closeContextMenu2);
    this.finResizeTabla?.();
  }

  /** Alto (px) de la tabla superior en las pestañas con dos tablas; null = alto por defecto del CSS. */
  public altoTablaSup: Record<string, number | null> = Object.fromEntries(
    StrategyFactoryComponent.CLAVES_ALTO_TABLA.map(c => [c, StrategyFactoryComponent.leerAltoTabla(c)])
  );
  private static readonly CLAVES_ALTO_TABLA = ['mejora1', 'mejora2', 'mejora3', 'optimizar', 'reevaluar'];
  private finResizeTabla: (() => void) | null = null;

  private static leerAltoTabla(clave: string): number | null {
    try {
      const alto = Number(localStorage.getItem('strategyfactory_altoTabla_' + clave));
      if (alto > 0) return alto;
    } catch { }
    return null;
  }

  /** Arrastre del divisor entre las dos tablas de una pestaña: abajo agranda la superior, arriba la achica. */
  iniciarResizeTabla(ev: MouseEvent, clave: string, topEl: HTMLElement, tablas: (StrategyFactoryResultsTableComponent | undefined)[]) {
    ev.preventDefault();
    this.finResizeTabla?.();
    const startY = ev.clientY;
    const altoInicial = topEl.getBoundingClientRect().height;
    // La tabla inferior siempre conserva al menos 120px visibles
    const max = Math.max(80, (topEl.parentElement?.clientHeight ?? window.innerHeight) - 120);
    const refrescar = () => tablas.forEach(t => t?.actualizarViewport());
    const mover = (e: MouseEvent) => {
      this.altoTablaSup[clave] = Math.round(Math.min(max, Math.max(80, altoInicial + e.clientY - startY)));
      this.cdr.detectChanges();
      refrescar();
    };
    const soltar = () => {
      document.removeEventListener('mousemove', mover);
      document.removeEventListener('mouseup', soltar);
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
      this.finResizeTabla = null;
      const alto = this.altoTablaSup[clave];
      try { if (alto) localStorage.setItem('strategyfactory_altoTabla_' + clave, String(alto)); } catch { }
    };
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'row-resize';
    document.addEventListener('mousemove', mover);
    document.addEventListener('mouseup', soltar);
    this.finResizeTabla = soltar;
  }

  /** Tablas plegadas ('<pestaña>:sup' / '<pestaña>:inf'); se recuerda entre sesiones. */
  public tablaPlegada: Record<string, boolean> = (() => {
    try { return JSON.parse(localStorage.getItem('strategyfactory_tablasPlegadas') || '{}') || {}; } catch { return {}; }
  })();

  setTablaPlegada(clave: string, plegada: boolean, otra?: StrategyFactoryResultsTableComponent) {
    this.tablaPlegada = { ...this.tablaPlegada, [clave]: plegada };
    try { localStorage.setItem('strategyfactory_tablasPlegadas', JSON.stringify(this.tablaPlegada)); } catch { }
    // La otra tabla cambia de alto: recalcular su viewport tras el layout
    otra?.refreshViewport();
  }

  /** flex de la tabla superior: alto arrastrado salvo que alguna de las dos esté plegada (lo decide el CSS). */
  flexTablaSup(clave: string): string | null {
    const alto = this.altoTablaSup[clave];
    if (!alto || this.tablaPlegada[clave + ':sup'] || this.tablaPlegada[clave + ':inf']) return null;
    return '0 0 ' + alto + 'px';
  }

  altoTablaSupPx(clave: string): number | null {
    return this.flexTablaSup(clave) ? this.altoTablaSup[clave] : null;
  }

  /** Doble clic en el divisor: vuelve al alto por defecto. */
  resetAltoTabla(clave: string, tablas: (StrategyFactoryResultsTableComponent | undefined)[]) {
    this.altoTablaSup[clave] = null;
    try { localStorage.removeItem('strategyfactory_altoTabla_' + clave); } catch { }
    this.cdr.detectChanges();
    tablas.forEach(t => t?.actualizarViewport());
  }

  /** Ventanas de trabajo flotantes (sin backdrop, minimizables) abiertas desde esta pantalla. */
  private ventanasFlotantes: Record<string, MatDialogRef<any> | null> = {};

  /**
   * Abre una ventana flotante no modal (como el Asistente IA). Si ya hay una abierta con la misma clave
   * y `reemplazar` es false, la trae de vuelta (restaurada) en lugar de abrir otra.
   */
  private abrirVentanaFlotante<T>(clave: string, componente: any, config: MatDialogConfig, reemplazar = false): MatDialogRef<T> | null {
    const abierta = this.ventanasFlotantes[clave];
    if (abierta) {
      if (!reemplazar) {
        const inst: any = abierta.componentInstance;
        inst?.ventana?.restaurar?.();
        return null;
      }
      abierta.close();
    }
    const ref = this.dialog.open<T>(componente, {
      ...config,
      hasBackdrop: false,
      data: { ...(config.data || {}), flotante: true }
    });
    this.ventanasFlotantes[clave] = ref;
    ref.afterClosed().subscribe(() => {
      if (this.ventanasFlotantes[clave] === ref) this.ventanasFlotantes[clave] = null;
    });
    return ref;
  }

  showTabHelp(tabName: string, event: Event): void {
    event.stopPropagation();
    let helpData: HelpDialogData;

    switch (tabName) {
      case 'Algoritmo':
        helpData = {
          title: 'Algoritmo',
          items: [
            { term: 'Configuración del Algoritmo', description: 'Define los parámetros y condiciones para el análisis algorítmico.' },
            { term: 'Ejecución', description: 'Ejecuta el algoritmo con los parámetros configurados.' },
            { term: 'Resultados', description: 'Muestra los resultados del análisis algorítmico.' }
          ]
        };
        break;
      case 'Condiciones':
        helpData = {
          title: 'Condiciones',
          items: [
            { term: 'Gestión de Condiciones', description: 'Administra las condiciones de entrada y salida para el algoritmo.' },
            { term: 'Tipos de Condiciones', description: 'Condiciones técnicas, fundamentales y de mercado.' },
            { term: 'Combinación', description: 'Combina múltiples condiciones para crear estrategias complejas.' }
          ]
        };
        break;
      default:
        helpData = {
          title: tabName,
          items: [{ term: 'Información', description: 'Información sobre esta sección.' }]
        };
    }

    this.abrirVentanaFlotante('ayuda', HelpDialogComponent, {
      width: '450px',
      data: helpData
    }, true);
  }


  expandirDiv() {
    if (this._panelCloseTimer) { clearTimeout(this._panelCloseTimer); this._panelCloseTimer = null; }
    this.texto = "<<";
    this.mouseSobreDiv = true;
  }
  contraerDiv() {
    this.texto = ">>";
    this._panelCloseTimer = setTimeout(() => {
      this.mouseSobreDiv = false;
      this._panelCloseTimer = null;
    }, 120);
  }

  // Silencioso (sin toastr): corrige en vivo mientras el usuario gira el spinner nativo,
  // para que nunca se vea un valor fuera de rango. `[(ngModel)]` ya sincronizó el valor
  // (posiblemente "girado") antes de que este handler corra, así que solo hace falta clamparlo.
  // Igual que onFechaKeydown: bloquea el paso del spinner apenas se está en el límite.
  onFechaReevaluarKeydown(event: KeyboardEvent) {
    const el = event.target as HTMLInputElement;
    if (!el.value) return;
    if (event.key === 'ArrowUp' && el.max && el.value >= el.max) {
      event.preventDefault();
    } else if (event.key === 'ArrowDown' && el.min && el.value <= el.min) {
      event.preventDefault();
    }
  }

  onFechaInicialReevaluarInput(): void {
    if (!this.fechaInicialReevaluar) return;
    if (this.fechaInicialReevaluar < this.fechaMinimaDisponible) {
      this.fechaInicialReevaluar = this.fechaMinimaDisponible;
    } else if (this.fechaInicialReevaluar > this.today) {
      this.fechaInicialReevaluar = this.today;
    } else if (this.fechaInicialReevaluar > this.fechaFinalReevaluar) {
      this.fechaInicialReevaluar = this.fechaFinalReevaluar;
    }
  }

  onFechaFinalReevaluarInput(): void {
    if (!this.fechaFinalReevaluar) return;
    if (this.fechaFinalReevaluar > this.today) {
      this.fechaFinalReevaluar = this.today;
    } else if (this.fechaFinalReevaluar < this.fechaInicialReevaluar) {
      this.fechaFinalReevaluar = this.fechaInicialReevaluar;
    }
  }

  onFechaInicialReevaluarChange(): void {
    if (this.fechaInicialReevaluar < this.fechaMinimaDisponible) {
      this.toastr.error(`La fecha inicial no puede ser menor al primer dato disponible (${this.fechaMinimaDisponible})`);
      this.fechaInicialReevaluar = this.fechaMinimaDisponible;
    } else if (this.fechaInicialReevaluar > this.today) {
      this.toastr.error('La fecha inicial no puede ser mayor a hoy');
      this.fechaInicialReevaluar = this.today;
    } else if (this.fechaInicialReevaluar > this.fechaFinalReevaluar) {
      this.toastr.error('La fecha inicial no puede ser mayor a la fecha final');
      this.fechaInicialReevaluar = this.fechaFinalReevaluar;
    }
  }

  onFechaFinalReevaluarChange(): void {
    if (this.fechaFinalReevaluar > this.today) {
      this.toastr.error('La fecha final no puede ser mayor a hoy');
      this.fechaFinalReevaluar = this.today;
    } else if (this.fechaFinalReevaluar < this.fechaInicialReevaluar) {
      this.toastr.error('La fecha final no puede ser menor a la fecha inicial');
      this.fechaFinalReevaluar = this.fechaInicialReevaluar;
    }
  }

  reevaluarModelos(): void {
    // Si ya está en proceso, cancelar
    if (this.loadingReevaluar) {
      this.loadingReevaluar = false;
      if (this.algorithmSubscriptionFinal) {
        this.algorithmSubscriptionFinal.unsubscribe();
        this.algorithmSubscriptionFinal = null;
      }
      this.apisseservice.disconnect();
      this.toastr.success('Reevaluación cancelada', 'Cancelado');
      return;
    }

    if (this.selectionReevaluar.selected.length === 0) {
      this.toastr.error('Debe seleccionar al menos un modelo para reevaluar', 'Advertencia');
      return;
    }

    this.results.reevaluados = [];
    this.results.topResultsReevaluacion = [];
    this.selectedTab = 3; // Cambiar a la pestaña de reevaluación

    // Ejecutar una sola llamada con todos los modelos seleccionados
    this.buscarAlgoritmo(5, 0, this.selectionReevaluar.selected[0]);
  }


  onContextMenu(event: MouseEvent, result: any, source: 'main' | 'optimized' | 'optimized2' | 'optimized3' | 'reevaluacion' = 'main'): void {
    event.preventDefault();
    event.stopPropagation();

    this.selectedResult = result;
    this.selectedTableSource = source;
    this.showContextMenu = true;

    // Usar coordenadas de viewport (clientX/clientY) para position: fixed
    this.contextMenuX = event.clientX;
    this.contextMenuY = event.clientY;

    // Detectar cambios y ajustar posición después del render
    setTimeout(() => {
      this.adjustMenuPosition(this.ctxMenuRef?.nativeElement, event.clientX, event.clientY, 'main');
    });
  }

  private adjustMenuPosition(menuEl: HTMLElement | undefined, mouseX: number, mouseY: number, which: 'main' | 'cond') {
    if (!menuEl) return;

    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const rect = menuEl.getBoundingClientRect();
    const margin = 8;

    // Posicionar por defecto justo encima del mouse
    let top = mouseY - rect.height - margin;
    // Si no cabe arriba, lo ponemos debajo
    if (top < margin) {
      top = Math.min(mouseY + margin, vh - rect.height - margin);
    }

    // Alineación horizontal: a la derecha del cursor, corrigiendo si no cabe
    let left = mouseX + margin;
    if (left + rect.width > vw - margin) {
      left = Math.max(margin, mouseX - rect.width - margin);
    }

    if (which === 'main') {
      this.contextMenuX = left;
      this.contextMenuY = top;
    } else {
      this.contextMenuX2 = left;
      this.contextMenuY2 = top;
    }

    // Forzar detección de cambios después de actualizar las coordenadas
    // this.cdr?.detectChanges();
  }

  @HostListener('document:click', ['$event'])
  closeContextMenu(event: MouseEvent): void {
    if (!event.target || !(event.target as HTMLElement).closest('.context-menu')) {
      this.showContextMenu = false;
    }
  }

  mostrareditordeparametros(result: ResultItem): void {
    this.showContextMenu = false;

    console.log('Mostrando editor de parámetros para:', result);
    // Flotante y minimizable; si ya está abierta se restaura en lugar de abrir otra
    const dialogRef = this.abrirVentanaFlotante<EditarParametrosCondicionComponent>('parametros', EditarParametrosCondicionComponent, {
      width: '600px',
      data: { condition: result, token: this.token },
      panelClass: this.isDark ? 'dark-theme' : 'light-theme'
    });
    if (!dialogRef) return;
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        console.log('[Algoritmo] Edición cancelada');
        return;
      }
      this.optimizarCondicionData = res;
      this.results.seleccionado4 = [result];
      this.results.topResultsOptimizado4 = [];
      this.selectedTab = 2;
      console.log('[Algoritmo] Datos recibidos afterClosed:', res);
      this.buscarAlgoritmo(3, 0, result)
      // TODO: manejar res.template, res.params, res.combinations
    });
  }

  // modo 0 genetico, 1 fuerza bruta
  optimizarCondicion(result: ResultItem, modo: number, ejecutar: boolean): void {// 0 = genetica, 1 = fuerza bruta
    console.log('Optimizando condición:', result, 'Modo:', modo);

    // Determinar el origen: preferir selectedTableSource si está establecido,
    // sino inferirlo a partir de los arrays de resultados.
    let source = this.selectedTableSource;
    if (!source) {
      if (this.results?.seleccionado && this.results.seleccionado.includes(result)) source = 'main';
      else if (this.results?.seleccionado2 && this.results.seleccionado2.includes(result)) source = 'optimized';
      else if (this.results?.seleccionado3 && this.results.seleccionado3.includes(result)) source = 'optimized2';
    }

    // Mapear siempre a la pestaña padre 'Mejoras' y seleccionar la subtaba correspondiente
    if (source === 'main') {
      this.results.seleccionado = [result];
      this.selectedMejorasSubtab = 0; // Mejora 1
    } else if (source === 'optimized') {
      this.results.seleccionado2 = [result];
      this.selectedMejorasSubtab = 1; // Mejora 2
    } else if (source === 'optimized2') {
      this.results.seleccionado3 = [result];
      this.selectedMejorasSubtab = 2; // Mejora Final
    } else {
      // Fallback: si no se puede inferir, usar main
      this.results.seleccionado = [result];
      this.selectedMejorasSubtab = 0;
    }

    // Seleccionar la pestaña top-level 'Mejoras' (era el índice 1 antes de agrupar)
    this.selectedTab = 1;

    this.showContextMenu = false;
    this.notificacion = 'Optimizando condición...';
    if (ejecutar) this.buscarAlgoritmo(2, modo, result);
  }

  onTypeChange(value: string): void {
    console.log('Selected type:', value);
    if (value === 'TECNICOS' || value === 'RATIOS' || value === 'LISTAS' || value === 'PATRONES') {
      this.selectedType = value;
      this.selectedRowTecnico = null;
      this.selectedRowRatio = null;
      this.selectedRowLista = null;
      this.selectedRowPatron = null;
      console.log('Selected type changed to:', this.selectedType);
    }
  }

  applyIndicadoresFilterTecnicos(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.indicadoresDataSourceTecnicos.data = this.filterAndSortIndicadores(this.allIndicadoresTecnicos, filterValue, this.sortColumnTecnicos, this.sortDirectionTecnicos);
  }
  applyIndicadoresFilterPatrones(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.indicadoresDataSourcePatrones.data = this.filterAndSortIndicadores(this.allIndicadoresPatrones, filterValue, this.sortColumnPatrones, this.sortDirectionPatrones);
  }
  applyIndicadoresFilterRatios(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.indicadoresDataSourceRatios.data = this.filterAndSortIndicadores(this.allIndicadoresRatios, filterValue, this.sortColumnRatios, this.sortDirectionRatios);
  }
  applyIndicadoresFilterListas(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.indicadoresDataSourceListas.data = this.filterAndSortIndicadores(this.allIndicadoresListas, filterValue, this.sortColumnListas, this.sortDirectionListas);
  }

  toggleIndicadoresSearch(): void {
    this.indicadoresSearchOpen = !this.indicadoresSearchOpen;
    if (this.indicadoresSearchOpen) {
      setTimeout(() => this.indicadoresSearchInputRef?.nativeElement.focus());
    }
  }

  closeIndicadoresSearchIfEmpty(): void {
    if (!this.indicadoresFilterValue) {
      this.indicadoresSearchOpen = false;
    }
  }

  sortIndicadoresTecnicos(column: 'label' | 'action'): void {
    if (this.sortColumnTecnicos === column) {
      this.sortDirectionTecnicos = this.sortDirectionTecnicos === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnTecnicos = column;
      this.sortDirectionTecnicos = 'asc';
    }
    this.indicadoresDataSourceTecnicos.data = this.filterAndSortIndicadores(this.allIndicadoresTecnicos, this.indicadoresFilterValue, this.sortColumnTecnicos, this.sortDirectionTecnicos);
  }
  sortIndicadoresRatios(column: 'label' | 'action'): void {
    if (this.sortColumnRatios === column) {
      this.sortDirectionRatios = this.sortDirectionRatios === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnRatios = column;
      this.sortDirectionRatios = 'asc';
    }
    this.indicadoresDataSourceRatios.data = this.filterAndSortIndicadores(this.allIndicadoresRatios, this.indicadoresFilterValue, this.sortColumnRatios, this.sortDirectionRatios);
  }
  sortIndicadoresListas(column: 'label' | 'action'): void {
    if (this.sortColumnListas === column) {
      this.sortDirectionListas = this.sortDirectionListas === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnListas = column;
      this.sortDirectionListas = 'asc';
    }
    this.indicadoresDataSourceListas.data = this.filterAndSortIndicadores(this.allIndicadoresListas, this.indicadoresFilterValue, this.sortColumnListas, this.sortDirectionListas);
  }
  sortIndicadoresPatrones(column: 'label' | 'action'): void {
    if (this.sortColumnPatrones === column) {
      this.sortDirectionPatrones = this.sortDirectionPatrones === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnPatrones = column;
      this.sortDirectionPatrones = 'asc';
    }
    this.indicadoresDataSourcePatrones.data = this.filterAndSortIndicadores(this.allIndicadoresPatrones, this.indicadoresFilterValue, this.sortColumnPatrones, this.sortDirectionPatrones);
  }
  applyCondicionesFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.condicionesFilterValue = filterValue;
    this.refreshCondicionesDataSource();
  }

  toggleCondicionesSearch(): void {
    this.condicionesSearchOpen = !this.condicionesSearchOpen;
    if (this.condicionesSearchOpen) {
      setTimeout(() => this.condicionesSearchInputRef?.nativeElement.focus());
    }
  }

  closeCondicionesSearchIfEmpty(): void {
    if (!this.condicionesFilterValue) {
      this.condicionesSearchOpen = false;
    }
  }

  sortCondiciones(column: 'label' | 'action'): void {
    if (this.sortColumnCondiciones === column) {
      this.sortDirectionCondiciones = this.sortDirectionCondiciones === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnCondiciones = column;
      this.sortDirectionCondiciones = 'asc';
    }
    this.refreshCondicionesDataSource();
  }


  onSelectIndicadorTecnicos(row: any, syncConditions = true): void {
    this.explicitlyDeselectedRows.delete(row);
    this.selectedRowTecnico = row;
    this.actualcondicion = row.label;
    this.selectionCondiciones.clear();
    if (row && row.label) {
      this.apisseservice.apiPostNew('condicionesporindicador', { indicador: row.label }, this.token).subscribe({
        next: (response: any) => {
          this.setCondicionesData(response.condiciones.map((condicion: Condicion) => ({
            label: condicion.indicador,
            action: 'true',
            type: this.selectedType,
            editable: condicion.editable || false,
            idindicador: condicion.idindicador
          })));
          if (syncConditions && this.selectionTecnicos.isSelected(row)) {
            this.condicionesDataSource.data.forEach(c => this.selectionCondiciones.select(c));
          }
          this.selectedTab = 4;
        },
        error: (error: Error) => {
          console.error('Error loading condiciones:', error);
          this.error = 'Error cargando las condiciones d';
        }
      });
    }
  }
  onSelectIndicadorRatios(row: any, syncConditions = true): void {
    this.explicitlyDeselectedRows.delete(row);
    this.selectedRowRatio = row;
    this.actualcondicion = row.label;
    this.selectionCondiciones.clear();
    if (row && row.label) {
      this.apisseservice.apiPostNew('condicionesporindicador', { indicador: row.label }, this.token).subscribe({
        next: (response: any) => {
          this.setCondicionesData(response.condiciones.map((condicion: Condicion) => ({
            label: condicion.indicador,
            action: 'true',
            type: this.selectedType,
            editable: condicion.editable || false,
            idindicador: condicion.idindicador
          })));
          if (syncConditions && this.selectionRatios.isSelected(row)) {
            this.condicionesDataSource.data.forEach(c => this.selectionCondiciones.select(c));
          }
          this.selectedTab = 4;
        },
        error: (error: Error) => {
          console.error('Error loading condiciones:', error);
          this.error = 'Error cargando las condiciones f';
        }
      });
    }
  }
  onSelectIndicadorListas(row: any, syncConditions = true): void {
    this.explicitlyDeselectedRows.delete(row);
    this.selectedRowLista = row;
    this.actualcondicion = row.label;
    this.selectionCondiciones.clear();
    if (row && row.label) {
      this.apisseservice.apiPostNew('condicionesporindicador', { indicador: row.label }, this.token).subscribe({
        next: (response: any) => {
          this.setCondicionesData(response.condiciones.map((condicion: Condicion) => ({
            label: condicion.indicador,
            action: 'true',
            type: this.selectedType,
            editable: condicion.editable || false,
            idindicador: condicion.idindicador
          })));
          if (syncConditions && this.selectionListas.isSelected(row)) {
            this.condicionesDataSource.data.forEach(c => this.selectionCondiciones.select(c));
          }
          this.selectedTab = 4;
        },
        error: (error: Error) => {
          console.error('Error loading condiciones:', error);
          this.error = 'Error cargando las condiciones e';
        }
      });
    }
  }

  onSelectIndicadorPatrones(row: any, syncConditions = true): void {
    this.explicitlyDeselectedRows.delete(row);
    this.selectedRowPatron = row;
    this.actualcondicion = row.label;
    this.selectionCondiciones.clear();
    if (row && row.label) {
      this.apisseservice.apiPostNew('condicionesporindicador', { indicador: row.label }, this.token).subscribe({
        next: (response: any) => {
          this.setCondicionesData(response.condiciones.map((condicion: Condicion) => ({
            label: condicion.indicador,
            action: 'true',
            type: this.selectedType,
            editable: condicion.editable || false,
            idindicador: condicion.idindicador
          })));
          if (syncConditions && this.selectionPatrones.isSelected(row)) {
            this.condicionesDataSource.data.forEach(c => this.selectionCondiciones.select(c));
          }
          this.selectedTab = 4;
        },
        error: (error: Error) => {
          console.error('Error loading condiciones:', error);
          this.error = 'Error cargando las condiciones patrones';
        }
      });
    }
  }
  private loadConditions(): void {
    if (!this.menuData.length) return;

    let tecnico = true;
    if (this.selectedType === 'RATIOS') {
      tecnico = false;
    }

    this.loadingIndicadoresCondiciones = true;
    this.apisseservice.apiPostNew('listaindicadoresportecnico3?tecnico=true&patrones=false', {}, this.token).subscribe({
      next: (indicators: IndicatorResponse[]) => {
        const conditions: Condition[] = indicators.map(item => ({
          label: item.indicador,
          action: item.contador.toString(),
          type: this.selectedType,
          id: item.id,
          idsList: item.idsList // añadido: no aplica en técnicos
        }));

        this.allIndicadoresTecnicos = conditions;
        this.indicadoresDataSourceTecnicos.data = this.filterAndSortIndicadores(conditions, this.indicadoresFilterValue, this.sortColumnTecnicos, this.sortDirectionTecnicos);
        this.loadingIndicadoresCondiciones = false;
      },
      error: (error: Error) => {
        console.error('Error loading indicators:', error);
        this.error = 'Error cargando los indicadores';
        this.loadingIndicadoresCondiciones = false;
      }
    });

    this.apisseservice.apiPostNew('listaindicadoresportecnico3?tecnico=false&patrones=false', {}, this.token).subscribe({
      next: (indicators: IndicatorResponse[]) => {
        const conditions: Condition[] = indicators.map(item => ({
          label: item.indicador,
          action: item.contador.toString(),
          type: this.selectedType,
          id: item.id,
          idsList: item.idsList // añadido: no aplica en ratios
        }));

        this.allIndicadoresRatios = conditions;
        this.indicadoresDataSourceRatios.data = this.filterAndSortIndicadores(conditions, this.indicadoresFilterValue, this.sortColumnRatios, this.sortDirectionRatios);
        this.loadingIndicadoresCondiciones = false;
      },
      error: (error: Error) => {
        console.error('Error loading indicators:', error);
        this.error = 'Error cargando los indicadores';
        this.loadingIndicadoresCondiciones = false;
      }
    });
      this.apisseservice.apiPostNew('listaindicadoresportecnico3?tecnico=true&patrones=true', {}, this.token).subscribe({
      next: (indicators: IndicatorResponse[]) => {
        const conditions: Condition[] = indicators.map(item => ({
          label: item.indicador,
          action: item.contador.toString(),
          type: this.selectedType,
          id: item.id,
          idsList: item.idsList // añadido: no aplica en ratios
        }));

        this.allIndicadoresPatrones = conditions;
        this.indicadoresDataSourcePatrones.data = this.filterAndSortIndicadores(conditions, this.indicadoresFilterValue, this.sortColumnPatrones, this.sortDirectionPatrones);
        this.loadingIndicadoresCondiciones = false;
      },
      error: (error: Error) => {
        console.error('Error loading indicators:', error);
        this.error = 'Error cargando los indicadores';
        this.loadingIndicadoresCondiciones = false;
      }
    });

    this.apisseservice.apiPostNew('listaindicadoresporusuario', {}, this.token).subscribe({
      next: (indicators: IndicatorResponse[]) => {
        const conditions: Condition[] = indicators.map(item => ({
          label: item.indicador,
          action: item.contador.toString(),
          type: this.selectedType,
          id: item.id,
          idsList: item.idsList
        }));

        this.allIndicadoresListas = conditions;
        this.indicadoresDataSourceListas.data = this.filterAndSortIndicadores(conditions, this.indicadoresFilterValue, this.sortColumnListas, this.sortDirectionListas);
        this.loadingIndicadoresCondiciones = false;
      }
      , error: (error: Error) => {
        console.error('Error loading user indicators:', error);
        this.error = 'Error cargando los indicadores del usuario';
        this.loadingIndicadoresCondiciones = false;
      }
    });
  }

  // Optional: method to get selected items
  getSelectedItems(): any[] {
    return this.selectionTecnicos.selected;
  }

  onCondicionContextMenu(event: MouseEvent, condicion: any): void {
    event.preventDefault();
    event.stopPropagation();

    this.showContextMenu = false;
    this.selectedCondicion = condicion;
    this.showContextMenu2 = true;

    // Usar coordenadas de viewport para position: fixed
    this.contextMenuX2 = event.clientX;
    this.contextMenuY2 = event.clientY;

    // Ajustar posición después del render
    setTimeout(() => {
      this.adjustMenuPosition(this.ctxMenu2Ref?.nativeElement, event.clientX, event.clientY, 'cond');
      window.addEventListener('click', this.closeContextMenu2);
    });
  }
  // Método para cerrar el menú contextual de condiciones
  closeContextMenu2 = (): void => {
    this.showContextMenu2 = false;
    window.removeEventListener('click', this.closeContextMenu2);
  }

  // Optimización para selección masiva rápida en masterToggleTecnicos

  masterToggleTecnicos() {
    const data = this.indicadoresDataSourceTecnicos.data || [];

    if (this.selectionTecnicos.selected.length === data.length && data.length > 0) {
      this.selectionTecnicos.clear();
    } else {
      // Evita duplicados y solo selecciona los que no están ya seleccionados
      const toSelect = data.filter(item => !this.selectionTecnicos.isSelected(item));
      this.selectionTecnicos.select(...toSelect);
    }
  }
  masterToggleListas() {
    const data = this.indicadoresDataSourceListas.data || [];
    if (this.selectionListas.selected.length === data.length && data.length > 0) {
      this.selectionListas.clear();
    } else {
      // Evita duplicados y solo selecciona los que no están ya seleccionados
      const toSelect = data.filter(item => !this.selectionListas.isSelected(item));
      this.selectionListas.select(...toSelect);
    }
  }

  isAllSelectedTecnicos() {
    const data = this.indicadoresDataSourceTecnicos.data || [];
    return this.selectionTecnicos.selected.length === data.length && data.length > 0;
  }
  isAllSelectedListas() {
    const data = this.indicadoresDataSourceListas.data || [];
    return this.selectionListas.selected.length === data.length && data.length > 0;
  }
  masterToggleRatios() {
    const data = this.indicadoresDataSourceRatios.data || [];

    if (this.selectionRatios.selected.length === data.length && data.length > 0) {
      this.selectionRatios.clear();
    } else {
      // Selecciona solo los que no están ya seleccionados
      const toSelect = data.filter(item => !this.selectionRatios.isSelected(item));
      this.selectionRatios.select(...toSelect);
    }
  }

  isAllSelectedRatios() {
    const data = this.indicadoresDataSourceRatios.data || [];
    return this.selectionRatios.selected.length === data.length && data.length > 0;
  }

  masterTogglePatrones() {
    const data = this.indicadoresDataSourcePatrones.data || [];
    if (this.selectionPatrones.selected.length === data.length && data.length > 0) {
      this.selectionPatrones.clear();
    } else {
      const toSelect = data.filter(item => !this.selectionPatrones.isSelected(item));
      this.selectionPatrones.select(...toSelect);
    }
  }

  isAllSelectedPatrones() {
    const data = this.indicadoresDataSourcePatrones.data || [];
    return this.selectionPatrones.selected.length === data.length && data.length > 0;
  }

  toggleSelectionPatrones(row: any) {
    this.selectionPatrones.toggle(row);
    if (this.selectionPatrones.isSelected(row)) {
      this.explicitlyDeselectedRows.delete(row);
      if (row === this.selectedRowPatron) {
        this.condicionesDataSource.data.forEach(c => this.selectionCondiciones.select(c));
      }
    } else {
      this.explicitlyDeselectedRows.add(row);
      if (row === this.selectedRowPatron) {
        this.selectionCondiciones.clear();
      }
    }
  }

  private getActiveIndicatorSelection(): { row: any, selection: SelectionModel<any> } | null {
    if (this.selectedRowTecnico) return { row: this.selectedRowTecnico, selection: this.selectionTecnicos };
    if (this.selectedRowRatio) return { row: this.selectedRowRatio, selection: this.selectionRatios };
    if (this.selectedRowLista) return { row: this.selectedRowLista, selection: this.selectionListas };
    if (this.selectedRowPatron) return { row: this.selectedRowPatron, selection: this.selectionPatrones };
    return null;
  }

  onToggleCondicion(row: any): void {
    this.selectionCondiciones.toggle(row);
    const active = this.getActiveIndicatorSelection();
    if (!active) return;
    const selectedCount = this.condicionesDataSource.data.filter(c => this.selectionCondiciones.isSelected(c)).length;
    if (selectedCount > 0) {
      active.selection.select(active.row);
    } else {
      active.selection.deselect(active.row);
    }
  }

  isIndicatorIndeterminate(row: any, selectedRow: any, selection: SelectionModel<any>): boolean {
    if (row !== selectedRow) return false;
    if (!selection.isSelected(row)) {
      // Indeterminado solo si fue abierto por el robot (no desmarcado explícitamente)
      return !this.explicitlyDeselectedRows.has(row);
    }
    const total = this.condicionesDataSource.data.length;
    if (!total) return false;
    const selected = this.condicionesDataSource.data.filter(c => this.selectionCondiciones.isSelected(c)).length;
    return selected > 0 && selected < total;
  }

  // Add new selection model for condiciones
  isAllSelectedCondiciones() {
    const numSelected = this.selectionCondiciones.selected.length;
    const numRows = this.condicionesDataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  masterToggleCondiciones() {
    const active = this.getActiveIndicatorSelection();
    if (this.isAllSelectedCondiciones()) {
      this.selectionCondiciones.clear();
      if (active) active.selection.deselect(active.row);
    } else {
      this.condicionesDataSource.data.forEach(row => this.selectionCondiciones.select(row));
      if (active) active.selection.select(active.row);
    }
  }

  toggleSelectionTecnicos(row: any) {
    this.selectionTecnicos.toggle(row);
    if (this.selectionTecnicos.isSelected(row)) {
      this.explicitlyDeselectedRows.delete(row);
      if (row === this.selectedRowTecnico) {
        this.condicionesDataSource.data.forEach(c => this.selectionCondiciones.select(c));
      }
    } else {
      this.explicitlyDeselectedRows.add(row);
      if (row === this.selectedRowTecnico) {
        this.selectionCondiciones.clear();
      }
    }
  }
  toggleSelectionRatios(row: any) {
    this.selectionRatios.toggle(row);
    if (this.selectionRatios.isSelected(row)) {
      this.explicitlyDeselectedRows.delete(row);
      if (row === this.selectedRowRatio) {
        this.condicionesDataSource.data.forEach(c => this.selectionCondiciones.select(c));
      }
    } else {
      this.explicitlyDeselectedRows.add(row);
      if (row === this.selectedRowRatio) {
        this.selectionCondiciones.clear();
      }
    }
  }
  toggleSelectionListas(row: any) {
    this.selectionListas.toggle(row);
    if (this.selectionListas.isSelected(row)) {
      this.explicitlyDeselectedRows.delete(row);
      if (row === this.selectedRowLista) {
        this.condicionesDataSource.data.forEach(c => this.selectionCondiciones.select(c));
      }
    } else {
      this.explicitlyDeselectedRows.add(row);
      if (row === this.selectedRowLista) {
        this.selectionCondiciones.clear();
      }
    }
  }

  eliminarCondicionesSeleccionadas(): void {
    const selected = this.selectionCondiciones.selected;
    if (!selected.length) return;
    const isAdmin = this.cookieService.get('user_type_id') === '1';
    const toDelete = selected.filter((c: any) => c.editable || isAdmin);
    const skipped = selected.length - toDelete.length;
    if (!toDelete.length) {
      this.toastr.error('Ninguna de las condiciones seleccionadas es eliminable');
      return;
    }
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    const dialogRef = this.dialog.open(DialogConfirmacionComponent, {
      width: '350px',
      panelClass: dialogClass,
      data: {
        titulo: 'Confirmar eliminación',
        mensaje: `¿Eliminar ${toDelete.length} condición(es)?${skipped ? ` (${skipped} omitida(s) por permisos)` : ''}`,
        botonConfirmar: 'Eliminar',
        botonCancelar: 'Cancelar'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
      this.loading = true;
      from(toDelete).pipe(
        concatMap((condicion: any) => this.http.delete(`${global.url}conditions/condiciones/${condicion.idindicador}`))
      ).subscribe({
        error: (err: any) => {
          this.loading = false;
          console.error('Error eliminando condiciones:', err);
          this.toastr.error('Error eliminando condiciones');
        },
        complete: () => {
          this.selectionCondiciones.clear();
          this.loading = false;
          this.toastr.success(`${toDelete.length} condición(es) eliminada(s) correctamente`);
          this.apisseservice.apiPostNew('condicionesporindicador', { indicador: this.actualcondicion }, this.token).subscribe({
            next: (response: any) => {
              this.setCondicionesData(response.condiciones.map((condicion: Condicion) => ({
                label: condicion.indicador,
                action: 'true',
                type: this.selectedType,
                editable: condicion.editable || false,
                idindicador: condicion.idindicador
              })));
            }
          });
        }
      });
    });
  }

  editarCondicion(event: Event): void {
    // Evitar que se propague y seleccione la fila
    event.stopPropagation();
    this.showContextMenu2 = false;

    // Lógica para editar la condición
    console.log('Editando condición:');
    console.log(this.selectedCondicion);
    // Aquí puedes abrir un diálogo o redirigir a una página de edición
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    console.log(dialogClass);
    if (this.selectedCondicion.editable) {
      const dialogRef = this.abrirVentanaFlotante<DialogCondicionComponent>('condicion', DialogCondicionComponent, {
        width: '500px',
        panelClass: dialogClass,
        data: { condicion: this.selectedCondicion, indicatorsIaSinEspacios: this.planificadorsv.indicatorsIaSinEspacios, theme: this.isDark ? 'dark' : 'light' }
      });
      if (!dialogRef) return;
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // Dialog was closed with a result (updated condition)
          this.toastr.success('Condición actualizada correctamente');
          // Reload the conditions list to reflect changes
          this.apisseservice.apiPostNew('condicionesporindicador', {
            indicador: this.actualcondicion
          }, this.token).subscribe({
            next: (response: any) => {
              this.setCondicionesData(response.condiciones.map((condicion: Condicion) => ({
                label: condicion.indicador,
                action: 'true',
                type: this.selectedType,
                editable: condicion.editable || false,
                idindicador: condicion.idindicador
              })));
            },
            error: (error: Error) => {
              console.error('Error reloading conditions:', error);
              this.error = 'Error actualizando la lista de condiciones';
            }
          });
        } else {
          // Dialog was cancelled or closed without changes
          console.log('Dialog closed without changes');
        }
      });
    }
    else this.toastr.error('Esta condición no es editable');
  }

  eliminarCondicion(event: Event): void {
    // Evitar que se propague y seleccione la fila
    event.stopPropagation();
    this.showContextMenu2 = false;

    // Lógica para eliminar la condición
    console.log('Eliminando condición:' + this.selectedCondicion);

    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    if (!this.selectedCondicion.editable && this.cookieService.get('user_type_id') != '1') {
      this.toastr.error('Esta condición no es editable');
    } else {
      const dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '350px',
        panelClass: dialogClass,
        data: {
          titulo: 'Confirmar eliminación',
          mensaje: '¿Está seguro que desea eliminar esta condición?',
          botonConfirmar: 'Eliminar',
          botonCancelar: 'Cancelar'
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // El usuario confirmó, proceder con la eliminación
          this.loading = true;
          this.http.delete(`${global.url}conditions/condiciones/${this.selectedCondicion.idindicador}`)
            .subscribe({
              next: (response: any) => {
                this.loading = false;
                //  if (response && response.status) {
                this.toastr.success('Condición eliminada correctamente');
                this.apisseservice.apiPostNew('condicionesporindicador', { indicador: this.actualcondicion }, this.token).subscribe({
                  next: (response: any) => {
                    this.setCondicionesData(response.condiciones.map((condicion: Condicion) => ({
                      label: condicion.indicador,
                      action: 'true',
                      type: this.selectedType,
                      editable: condicion.editable || false,
                      idindicador: condicion.idindicador
                    })));
                  },
                  error: (error: Error) => {
                    console.error('Error loading condiciones:', error);
                    this.error = 'Error cargando las condiciones d';
                  }
                });
                //   } else {
                //    this.toastr.error(response.message || 'Error al eliminar la condición');
                //  }
              },
              error: (error) => {
                console.error('Error al eliminar condición:', error);

              }
            });

        }
      });
    }
  }
  eliminarLista($event: Event, condicion: any) {
    console.log(condicion);
    this.apisseservice.apiPostNew('eliminarcondicion', { idindicador: condicion.id }, this.token).subscribe({
      next: (response: any) => {
        this.toastr.success('Lista eliminada correctamente');
        // refrescar de nuevo la lista
        this.recargarIdeas();
      },
      error: (error: Error) => {
        console.error('Error al eliminar la condición:', error);
        this.toastr.error('Error al eliminar la condición');
      }
    });

  }
  copiarCondicion(event: Event): void {
    // Evitar que se propague y seleccione la fila
    event.stopPropagation();
    this.showContextMenu2 = false;
    // Guardar la condición seleccionada
    this.condicionCopiada = { ...this.selectedCondicion };

    // Notificar al usuario
    this.toastr.success('Condición copiada correctamente. Puedes pegarla desde el botón "Pegar"');

    console.log('Condición copiada:', this.condicionCopiada);
  }
  cortarCondicion(event: Event): void {
    // Evitar que se propague y seleccione la fila
    event.stopPropagation();
    this.showContextMenu2 = false;

    // Lógica para cortar la condición
    console.log('Cortando condición:');
    // Implementa aquí tu lógica de corte
  }

  pegarCondicion(): void {
    if (!this.condicionCopiada) {
      this.toastr.error('No hay ninguna condición copiada para pegar');
      return;
    }

    // Crear una nueva condición basada en la copiada
    const nuevaCondicion = {
      ...this.condicionCopiada,
      idindicador: 0 // La nueva condición tendrá un nuevo ID cuando se guarde
    };

    // Abrir el diálogo para editar/confirmar la nueva condición
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    const dialogRef = this.abrirVentanaFlotante<DialogCondicionComponent>('condicion', DialogCondicionComponent, {
      width: '500px',
      panelClass: dialogClass,
      data: {
        condicion: nuevaCondicion,
        esCopia: true, indicatorsIaSinEspacios: this.planificadorsv.indicatorsIaSinEspacios, origen: this.actualcondicion
      }
    });
    if (!dialogRef) return;

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // El usuario confirmó, guardar la nueva condición
        this.loading = true;
        console.log('Guardando condición pegada:', result);

        this.toastr.success('Condición pegada y guardada correctamente');

        // Recargar las condiciones para mostrar la nueva
        this.apisseservice.apiPostNew('condicionesporindicador', { indicador: this.actualcondicion }, this.token).subscribe({
          next: (response: any) => {
            this.setCondicionesData(response.condiciones.map((condicion: Condicion) => ({
              label: condicion.indicador,
              action: 'true',
              type: this.selectedType,
              editable: condicion.editable || false,
              idindicador: condicion.idindicador
            })));
          },
          error: (error: Error) => {
            console.error('Error cargando condiciones:', error);
          }
        });


      }
    });
  }

  clearSelectionReevaluar(): void {
    this.selectionReevaluar.clear();
    this.modelosSeleccionadosReevaluarCache = [];
    this.cdr.markForCheck();
  }

  get modelosSeleccionadosReevaluar(): ResultItem[] {
    return this.modelosSeleccionadosReevaluarCache;
  }

  // Método para actualizar el cache cuando cambia la selección
  actualizarSeleccionReevaluar(): void {
    // Debug log to trace selection updates from nested tables
    console.log('actualizarSeleccionReevaluar called - selected count:', this.selectionReevaluar.selected.length);
    this.modelosSeleccionadosReevaluarCache = [...this.selectionReevaluar.selected];
    this.cdr.markForCheck();
  }

  private resyncSelectionByGroup(): void {
    const selectedGroups = new Set(this.selectionReevaluar.selected.map(r => r.group));
    if (selectedGroups.size === 0) return;
    this.selectionReevaluar.clear();
    const toReselect = this.results.topResults.filter(r => selectedGroups.has(r.group));
    if (toReselect.length > 0) {
      this.selectionReevaluar.select(...toReselect);
    }
    this.actualizarSeleccionReevaluar();
  }

  getReevalMatchId(item: ResultItem): number | null {
    const index = this.modelosSeleccionadosReevaluarCache.findIndex(m => {
      // Comparar condiciones
      const conditionMatch =
        (m.condition && item.condition && m.condition === item.condition) ||
        (m.conditions && item.conditions && JSON.stringify(m.conditions) === JSON.stringify(item.conditions));

      if (!conditionMatch) return false;

      // Comparar stopLoss (considerar undefined === undefined como match)
      const stopLossMatch = m.stopLoss === item.stopLoss;

      // Comparar valorriesgo (considerar undefined === undefined como match)
      const valorRiesgoMatch = m.valorriesgo === item.valorriesgo;

      return conditionMatch && stopLossMatch && valorRiesgoMatch;
    });
    return index >= 0 ? index + 1 : null;
  }
// Mismo texto para la lupa (chatgpt.com) y para el asistente: si divergen, también divergen los resultados.
// Las reglas de formato van dentro porque chatgpt.com no recibe el prompt de sistema del asistente.
// El 20 coincide con asistente.max-condiciones del backend.
private promptIndicador(nombreIndicador: string, tecnico: boolean, patrones: boolean): string {
  const reglas = `Entrega exactamente 20 condiciones numeradas del 1 al 20, agrupadas por categoría con títulos cortos.
Cada condición va en una sola línea, con sus cláusulas unidas con AND y en notación compacta (EMA(20), RSI(14), close, ATR(14)[1]), sin bloques de código, etiquetas ni marco temporal dentro de la condición.
Todas las condiciones deben comenzar con ${nombreIndicador}.`;
  if (patrones) {
    return `Actúa como un trader cuantitativo profesional especializado en patrones gráficos de precios de activos financieros.
Genera condiciones 'patrones: ${nombreIndicador}' utilizando operadores lógicos (>, <, =, AND, OR, %, /, ^, desde, hasta), periodos anteriores, cruces, ratios, relaciones, fórmulas matemáticas y comparaciones entre periodos de velas candlesticks.
${reglas}`;
  }
  if (!tecnico) {
    return `Utiliza el Ratio Financiero (${nombreIndicador}) y actúa como un Inversor cuantitativo profesional. Genera condiciones de análisis fundamental utilizando operadores lógicos (>, <, =, AND, OR, %, /, ^), medias, periodos anteriores, cruces, ratios, relaciones, fórmulas matemáticas, análisis cuantitativos, comparaciones entre otros ratios, estadística descriptiva, percentiles y promedios.
Dame condiciones para capturar tendencias, roturas de volatilidad, Breakouts o breakdowns de precio (máximos/mínimos de X periodos).
Evita explicaciones y céntrate en condiciones útiles para inversión.
${reglas}`;
  }
  return `Utiliza el indicador ${nombreIndicador} y actúa como un trader cuantitativo profesional. Genera condiciones de análisis técnico utilizando operadores lógicos (>, <, =, AND, OR, %, /, ^), medias, periodos anteriores, cruces, ratios, relaciones, fórmulas matemáticas, análisis cuantitativos, comparaciones entre otros indicadores, estadística descriptiva, percentiles, roturas de precio, gaps y volatilidad.
Evita explicaciones y céntrate en condiciones útiles para trading intradía y swing.
${reglas}`;
}

searchIndicatorInChatGPT(nombreIndicador: string, tecnico: boolean, patrones: boolean = false) {
    const selectedIndicator = this.promptIndicador(nombreIndicador, tecnico, patrones);
    if (selectedIndicator) {
        // Construir la URL con el ítem seleccionado
        const query = encodeURIComponent(selectedIndicator);
        const url = `https://chat.openai.com/?q=${query}`;

        // Redirigir a la URL
        //window.location.href = url;
        window.open(url, '_blank');
    } else {
        console.warn('Por favor, seleccione un indicador antes de buscar.');
    }
}


searchIndicatorInChatListas(nombreIndicador: string, id: string) {
  this.chatIaOnSave = (condiciones: string[], direcciones: DireccionUI[]) => {
    this.aplicarDireccionIA(direcciones);
    const guardados = condiciones.map(condicion => {
      const condiccion = { indicador: condicion.replace(/#/g, '').trim(), jsonData: '' };
      return this.apisseservice.apiPostNew('conditions/condiciones', condiccion, this.token).pipe(
        concatMap((response: any) => this.apisseservice.apiPostNew('conditions/lista-condiciones', { idlista: id, idindicador: response.idindicador }, this.token)),
        map((relacion: any) => relacion?.yaEnLista ? 'duplicada' : 'ok'),
        catchError((e: any) => { console.error('Error al guardar condiciones:', e); return of(null); })
      );
    });
    forkJoin(guardados).subscribe(resultados => {
      const duplicadas = resultados.filter(r => r === 'duplicada').length;
      const fallidas = resultados.filter(r => r === null).length;
      this.notificarGuardadoCondicionesIA(resultados.length - fallidas - duplicadas, fallidas, ' y añadida(s) a la lista', duplicadas, ['ya estaba en la lista', 'ya estaban en la lista']);
    });
  };

  if (this.chatIaDialogRef) {
    this.chatIaDialogRef.componentInstance.onSaveCallback = this.chatIaOnSave;
    this.chatIaDialogRef.componentInstance.modoIdeas = false;
    this.chatIaDialogRef.componentInstance.resetAndQuery(`Ahora necesito condiciones para: ${nombreIndicador}`);
    return;
  }

  this.chatIaDialogRef = this.dialog.open(ChatIaDialogComponent, {
    width: '33vw',
    height: '70vh',
    panelClass: 'chat-ia-panel',
    disableClose: true,
    hasBackdrop: false,
    data: {
      condicionActual: '',
      token: this.cookieService.get('auth_token'),
      initialQuery: ''
    }
  });
  this.chatIaDialogRef.componentInstance.onSaveCallback = this.chatIaOnSave;
  this.chatIaDialogRef.afterClosed().subscribe(() => {
    this.chatIaDialogRef = null;
    this.chatIaOnSave = null;
  });

}
// Dónde se van a usar las condiciones: el asistente no puede adivinarlo (p. ej. MetaAPI no tiene ratios)
private contextoAsistente(tipo: 'tecnico' | 'ratio' | 'patron'): ContextoAsistenteUI {
  const mercado = this.mercados.find(m => m.idmercado == this.selectedIdMercado);
  return mercado ? { mercado: mercado.nombre, metaapi: !!mercado.metaapi, tipo } : { tipo };
}

searchIndicatorInChat(nombreIndicador: string, id: string, tecnico: boolean, patrones: boolean) {
  const pregunta = this.promptIndicador(nombreIndicador, tecnico, patrones);
  const tipo = patrones ? 'patron' : (tecnico ? 'tecnico' : 'ratio');

  this.chatIaOnSave = (condiciones: string[], direcciones: DireccionUI[]) => {
    this.aplicarDireccionIA(direcciones);
    const guardados = condiciones.map(condicion => {
      const limpia = condicion.replace(/#/g, '').trim();
      return this.apisseservice.apiPutNew('conditions/condiciones/' + id, { condicion: limpia, indicador: limpia, ia: true }, this.token).pipe(
        map(() => 'ok'),
        catchError((e: any) => {
          // 409: el usuario ya tenía guardada esa condición
          if (e?.status === 409) return of('duplicada');
          console.error('Error guardando condición IA:', e);
          return of(null);
        })
      );
    });
    forkJoin(guardados).subscribe(resultados => {
      const duplicadas = resultados.filter(r => r === 'duplicada').length;
      const fallidas = resultados.filter(r => r === null).length;
      this.notificarGuardadoCondicionesIA(resultados.length - fallidas - duplicadas, fallidas, '', duplicadas, ['ya estaba registrada', 'ya estaban registradas']);
    });
  };

  if (this.chatIaDialogRef) {
    this.chatIaDialogRef.componentInstance.onSaveCallback = this.chatIaOnSave;
    this.chatIaDialogRef.componentInstance.modoIdeas = true;
    this.chatIaDialogRef.componentInstance.contexto = this.contextoAsistente(tipo);
    this.chatIaDialogRef.componentInstance.resetAndQuery(pregunta);
    return;
  }

  this.chatIaDialogRef = this.dialog.open(ChatIaDialogComponent, {
    width: '33vw',
    height: '70vh',
    panelClass: 'chat-ia-panel',
    disableClose: true,
    hasBackdrop: false,
    data: {
      condicionActual: '',
      token: this.cookieService.get('auth_token'),
      initialQuery: pregunta,
      modoIdeas: true,
      contexto: this.contextoAsistente(tipo)
    }
  });
  this.chatIaDialogRef.componentInstance.onSaveCallback = this.chatIaOnSave;
  this.chatIaDialogRef.afterClosed().subscribe(() => {
    this.chatIaDialogRef = null;
    this.chatIaOnSave = null;
  });
}

// La ejecución tiene una sola dirección y las condiciones guardadas no la conservan: se aplica aquí, al guardar.
// Si se mezclan, no hay una correcta: se avisa y el selector no cambia.
private aplicarDireccionIA(direcciones: DireccionUI[]) {
  const distintas = new Set(direcciones);
  if (distintas.size > 1) {
    this.toastr.warning('Guardaste condiciones LONG y SHORT: cada ejecución usa una sola dirección, ejecútalas por separado.');
    return;
  }
  if (distintas.size === 0) return;
  const bajista = direcciones[0] === 'SHORT';
  if (this.optimalWallet.bajista !== bajista) {
    this.optimalWallet.bajista = bajista;
    this.toastr.info(`Dirección cambiada a ${bajista ? 'Bajista' : 'Alcista'} por las condiciones ${direcciones[0]}`);
  }
}

// Un único toast y una única recarga tras guardar en bloque condiciones del asistente IA
private notificarGuardadoCondicionesIA(ok: number, fallidas: number, sufijo: string, duplicadas = 0, motivoDuplicada: [string, string] = ['', '']) {
  if (ok > 0) {
    this.toastr.success(ok === 1 ? `Condición guardada${sufijo} correctamente` : `${ok} condiciones guardadas${sufijo} correctamente`);
    this.apisseservice.apiPostNew('condicionesporindicador', { indicador: this.actualcondicion }, this.token).subscribe({
      next: (r: any) => {
        this.setCondicionesData(r.condiciones.map((c: Condicion) => ({
          label: c.indicador, action: 'true', type: this.selectedType,
          editable: c.editable || false, idindicador: c.idindicador
        })));
      },
      error: (e: Error) => { console.error('Error loading condiciones:', e); this.error = 'Error cargando las condiciones'; }
    });
  }
  if (duplicadas > 0) {
    this.toastr.warning(duplicadas === 1
      ? `La condición no se ha guardado: ${motivoDuplicada[0]}`
      : `${duplicadas} condiciones no se han guardado: ${motivoDuplicada[1]}`);
  }
  if (fallidas > 0) {
    this.toastr.error(fallidas === 1 ? 'Error al guardar 1 condición generada por IA' : `Error al guardar ${fallidas} condiciones generadas por IA`);
  }
}
}



// Definir la interfaz localmente para independizarse del servicio
interface AlgoritmoResult {
  executionTime: string;
  useDemoData: boolean;
  totalOperations: number;
  totalResults: number;
  maxCombinaciones: number;
  conditionsEvaluated: number;
  tasaCompuestaObjetivo: number;
  totalConditions: number;
  mayorRetrocesoObjetivo: number;
  topResults: Array<{
    type: string;
    condition?: string;
    conditions?: string[];
    compoundRate: number;
    maxDrawdown: number;
    maxDrawdownObjetivo: number;
    maxDrawdownValor: number;
    beneficio: number;
    fracciones: boolean;
    tiporiesgo: string;
    operaciones: number;
    score: number;
    group: number;
    modelMeetsCriteria: string;
  }>;
  topResultsOptimizado: Array<{
    type: string;
    condition?: string;
    conditions?: string[];
    compoundRate: number;
    maxDrawdown: number;
    maxDrawdownObjetivo: number;
    maxDrawdownValor: number;
    beneficio: number;
    fracciones: boolean;

    tiporiesgo: string;
    operaciones: number;
    score: number;
    group: number;
    modelMeetsCriteria: string;

  }>;
  topResultsOptimizado2: Array<{
    type: string;
    condition?: string;
    conditions?: string[];
    compoundRate: number;
    maxDrawdown: number;
    maxDrawdownObjetivo: number;
    maxDrawdownValor: number;
    beneficio: number;
    fracciones: boolean;
    tiporiesgo: string;
    operaciones: number;
    score: number;
    group: number; modelMeetsCriteria: string;

  }>;
  topResultsOptimizado3: Array<{
    type: string;
    condition?: string;
    conditions?: string[];
    compoundRate: number;
    maxDrawdown: number;
    maxDrawdownObjetivo: number;
    beneficio: number;
    maxDrawdownValor: number;
    fracciones: boolean;
    tiporiesgo: string;
    operaciones: number;
    score: number;
    group: number; modelMeetsCriteria: string;

  }>;
  topResultsOptimizado4: Array<{
    type: string;
    condition?: string;
    conditions?: string[];
    compoundRate: number;
    maxDrawdown: number;
    maxDrawdownObjetivo: number;
    beneficio: number;
    maxDrawdownValor: number;
    fracciones: boolean;
    tiporiesgo: string;
    operaciones: number;
    score: number;
    group: number; modelMeetsCriteria: string;
  }>;
  topResultsReevaluacion: Array<{
    type: string;
    condition?: string;
    conditions?: string[];
    compoundRate: number;
    maxDrawdown: number;
    maxDrawdownObjetivo: number;
    beneficio: number;
    maxDrawdownValor: number;
    fracciones: boolean;
    tiporiesgo: string;
    operaciones: number;
    score: number;
    group: number; modelMeetsCriteria: string;
  }>;
  seleccionado: Array<{
    type: string;
    condition?: string;
    conditions?: string[];
    compoundRate: number;
    maxDrawdown: number;
    maxDrawdownObjetivo: number;
    beneficio: number;
    maxDrawdownValor: number;
    fracciones: boolean;
    tiporiesgo: string;
    operaciones: number;
    score: number;
    group: number; modelMeetsCriteria: string;

  }>;
  seleccionado2: Array<{
    type: string;
    condition?: string;
    conditions?: string[];
    compoundRate: number;
    maxDrawdown: number;
    maxDrawdownObjetivo: number;
    maxDrawdownValor: number;
    beneficio: number;
    fracciones: boolean;
    tiporiesgo: string;
    operaciones: number;
    score: number;
    group: number; modelMeetsCriteria: string;

  }>;
  seleccionado3: Array<{
    type: string;
    condition?: string;
    conditions?: string[];
    compoundRate: number;
    maxDrawdown: number;
    maxDrawdownObjetivo: number;
    maxDrawdownValor: number;
    beneficio: number;
    fracciones: boolean;
    tiporiesgo: string;
    operaciones: number;
    score: number;
    group: number; modelMeetsCriteria: string;

  }>;
  seleccionado4: Array<{
    type: string;
    condition?: string;
    conditions?: string[];
    compoundRate: number;
    maxDrawdown: number;
    maxDrawdownObjetivo: number;
    beneficio: number;
    maxDrawdownValor: number;
    fracciones: boolean;
    tiporiesgo: string;
    operaciones: number;
    score: number;
    group: number; modelMeetsCriteria: string;
  }>;
  seleccionadoReevaluacion: Array<{
    type: string;
    condition?: string;
    conditions?: string[];
    compoundRate: number;
    maxDrawdown: number;
    maxDrawdownObjetivo: number;
    beneficio: number;
    maxDrawdownValor: number;
    fracciones: boolean;
    tiporiesgo: string;
    operaciones: number;
    score: number;
    group: number; modelMeetsCriteria: string;
  }>;

  reevaluados: Array<{
    type: string;
    condition?: string;
    conditions?: string[];
    compoundRate: number;
    maxDrawdown: number;
    maxDrawdownObjetivo: number;
    beneficio: number;
    maxDrawdownValor: number;
    fracciones: boolean;
    tiporiesgo: string;
    operaciones: number;
    score: number;
    group: number;
    modelMeetsCriteria: string;
  }>;
  bestGroup: {
    id: number;
    compoundRate: number;
    maxDrawdown: number;
    modelMeetsCriteria: string;
    maxDrawdownObjetivo: number;
    maxDrawdownValor: number;
    beneficio: number;
    fracciones: boolean;
    tiporiesgo: string;
    score: number;
    type: string;
    message: string;
    conditions: string[];
    otherResults: Array<{
      type: string;
      conditions: string[];
      compoundRate: number;
      maxDrawdown: number;
      maxDrawdownObjetivo: number;
      maxDrawdownValor: number;
      beneficio: number;
      fracciones: boolean;
      tiporiesgo: string;
      score: number; modelMeetsCriteria: string;

    }>;
  };
}

// Definir la interfaz localmente para independizarse del servicio
interface ResultItem {
  type: string;
  condition?: string;
  conditions?: string[];
  compoundRate: number;
  maxDrawdown: number;
  maxDrawdownObjetivo: number;
  maxDrawdownValor: number;
  beneficio: number;
  fracciones: boolean;
  tiporiesgo: string;
  operaciones: number;
  score: number;
  group: number;
  modelMeetsCriteria: string;
  valorriesgo?: number;
  stopLoss?: number;
}

interface AlgorithmResults {
  topResults: ResultItem[];
  seleccionado: ResultItem[];
  seleccionado2: ResultItem[];  // Ahora usa el mismo tipo que seleccionado
  seleccionado3: ResultItem[];
  seleccionado4: ResultItem[];
  seleccionadoReevaluacion: ResultItem[];
  topResultsOptimizado: ResultItem[];
  topResultsOptimizado2: ResultItem[];
  topResultsOptimizado3: ResultItem[];
  topResultsOptimizado4: ResultItem[];
  topResultsReevaluacion: ResultItem[];
  reevaluados: ResultItem[];
}

export { ResultItem, AlgorithmResults };


